// src/pages/LeavesList.jsx
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { FaTimes, FaEdit, FaSearch, FaFilter, FaDownload, FaChevronLeft, FaChevronRight } from "react-icons/fa";

// const LeavesList = () => {
//   const [leaves, setLeaves] = useState([]);
//   const [filteredLeaves, setFilteredLeaves] = useState([]);
//   const [currentPageLeaves, setCurrentPageLeaves] = useState([]);
//   const [editingRecord, setEditingRecord] = useState(null);
//   const [updatedStatus, setUpdatedStatus] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Search and Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");

//   // Pagination States
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);

//   const fetchLeaves = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get("https://api.timelyhealth.in/api/leaves/leaves");
//       const leavesData = res.data.records || res.data || [];

//       // Sort by latest first
//       const sortedLeaves = leavesData.sort((a, b) => new Date(b.createdAt || b.startDate) - new Date(a.createdAt || a.startDate));
//       setLeaves(sortedLeaves);
//       setFilteredLeaves(sortedLeaves);
//     } catch (err) {
//       console.error("Failed to fetch leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   // Apply filters
//   useEffect(() => {
//     let filtered = leaves;

//     // Search filter
//     if (searchTerm) {
//       filtered = filtered.filter(leave =>
//         leave.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         leave.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         leave.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         leave.reason?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     // Status filter
//     if (statusFilter !== "all") {
//       filtered = filtered.filter(leave => leave.status === statusFilter);
//     }

//     // Leave type filter
//     if (leaveTypeFilter !== "all") {
//       filtered = filtered.filter(leave => leave.leaveType === leaveTypeFilter);
//     }

//     setFilteredLeaves(filtered);
//     setCurrentPage(1); // Reset to first page when filters change
//   }, [searchTerm, statusFilter, leaveTypeFilter, leaves]);

//   // Pagination logic
//   useEffect(() => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     setCurrentPageLeaves(filteredLeaves.slice(indexOfFirstItem, indexOfLastItem));
//   }, [currentPage, filteredLeaves, itemsPerPage]);

//   const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

//   const handleEdit = (rec) => {
//     setEditingRecord(rec);
//     setUpdatedStatus(rec.status);
//   };

//   const handleUpdateStatus = async () => {
//     if (!["pending", "approved", "rejected"].includes(updatedStatus)) {
//       alert("Status must be Pending, Approved, or Rejected");
//       return;
//     }
//     try {
//       await axios.put(
//         `https://api.timelyhealth.in/api/leaves/updateleaves/${editingRecord._id}`,
//         { status: updatedStatus }
//       );
//       alert(`✅ Leave ${updatedStatus} successfully!`);
//       setEditingRecord(null);
//       fetchLeaves();
//     } catch (err) {
//       console.error("Failed to update status:", err);
//       alert("❌ Failed to update leave status");
//     }
//   };

//   const getStatusClass = (status) => {
//     switch (status.toLowerCase()) {
//       case "approved":
//         return "bg-emerald-50 text-emerald-700 border border-green-300";
//       case "rejected":
//         return "bg-red-50 text-red-700 border border-red-300";
//       case "pending":
//       default:
//         return "bg-amber-50 text-amber-700 border border-yellow-300";
//     }
//   };

//   const getStatusIcon = (status) => {
//     switch (status.toLowerCase()) {
//       case "approved":
//         return "✅";
//       case "rejected":
//         return "❌";
//       case "pending":
//       default:
//         return "⏳";
//     }
//   };

//   const getLeaveTypeClass = (type) => {
//     switch (type?.toLowerCase()) {
//       case "sick leave":
//         return "bg-blue-50 text-blue-700 border border-blue-300";
//       case "casual leave":
//         return "bg-purple-100 text-purple-800 border border-purple-300";
//       case "emergency leave":
//         return "bg-red-50 text-red-700 border border-red-300";
//       case "annual leave":
//         return "bg-emerald-50 text-emerald-700 border border-green-300";
//       default:
//         return "bg-gray-100 text-gray-700 border border-gray-300";
//     }
//   };

//   const clearFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("all");
//     setLeaveTypeFilter("all");
//   };

//   const downloadCSV = () => {
//     if (filteredLeaves.length === 0) {
//       alert("No data available to download!");
//       return;
//     }

//     const headers = [
//       "Employee Name",
//       "Employee ID",
//       "Leave Type",
//       "Start Date",
//       "End Date",
//       "Days",
//       "Reason",
//       "Status",
//       "Applied Date"
//     ];

//     const csvRows = [
//       headers.join(","),
//       ...filteredLeaves.map(leave =>
//         [
//           `"${leave.employeeName || 'N/A'}"`,
//           `"${leave.employeeId || 'N/A'}"`,
//           `"${leave.leaveType || 'N/A'}"`,
//           `"${new Date(leave.startDate).toLocaleDateString()}"`,
//           `"${new Date(leave.endDate).toLocaleDateString()}"`,
//           leave.days || '0',
//           `"${leave.reason || 'N/A'}"`,
//           leave.status,
//           `"${new Date(leave.createdAt || leave.startDate).toLocaleDateString()}"`
//         ].join(",")
//       ),
//     ];

//     const csvData = csvRows.join("\n");
//     const blob = new Blob([csvData], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `leave_requests_${new Date().toLocaleDateString().replace(/\//g, '-')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   // Get unique leave types for filter
//   const leaveTypes = [...new Set(leaves.map(leave => leave.leaveType).filter(Boolean))];

//   // Pagination controls
//   const goToPage = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const nextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const prevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   // Generate page numbers
//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     const maxPagesToShow = 5;

//     if (totalPages <= maxPagesToShow) {
//       for (let i = 1; i <= totalPages; i++) {
//         pageNumbers.push(i);
//       }
//     } else {
//       const startPage = Math.max(1, currentPage - 2);
//       const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

//       for (let i = startPage; i <= endPage; i++) {
//         pageNumbers.push(i);
//       }
//     }

//     return pageNumbers;
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-50 to-blue-100">
//         <div className="text-center">
//           <div className="w-16 h-16 mx-auto mb-4 border-b-2 border-purple-600 rounded-full animate-spin"></div>
//           <p className="text-lg font-semibold text-gray-700">Loading leave requests...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen px-4 py-8 bg-gradient-to-br from-purple-50 to-blue-100">
//       <div className="mx-auto max-w-7xl">
//         {/* Header Section */}
//         <div className="mb-8 text-center">
//           <h1 className="mb-3 text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
//             📋 Leave Requests Management
//           </h1>
//           <p className="text-lg text-gray-500">
//             Review and manage employee leave applications
//           </p>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-4">
//           <div className="p-6 text-center bg-white border border-purple-200 shadow-lg rounded-2xl">
//             <div className="text-3xl font-bold text-purple-600">{leaves.length}</div>
//             <div className="font-semibold text-purple-800">Total Requests</div>
//           </div>
//           <div className="p-6 text-center bg-white border border-yellow-200 shadow-lg rounded-2xl">
//             <div className="text-3xl font-bold text-yellow-600">
//               {leaves.filter(l => l.status === 'pending').length}
//             </div>
//             <div className="font-semibold text-yellow-800">Pending</div>
//           </div>
//           <div className="p-6 text-center bg-white border border-green-200 shadow-lg rounded-2xl">
//             <div className="text-3xl font-bold text-blue-700">
//               {leaves.filter(l => l.status === 'approved').length}
//             </div>
//             <div className="font-semibold text-green-800">Approved</div>
//           </div>
//           <div className="p-6 text-center bg-white border border-red-200 shadow-lg rounded-2xl">
//             <div className="text-3xl font-bold text-red-600">
//               {leaves.filter(l => l.status === 'rejected').length}
//             </div>
//             <div className="font-semibold text-red-800">Rejected</div>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="p-6 mb-8 bg-white border border-gray-200 shadow-lg rounded-2xl">
//           <div className="flex flex-col items-start justify-between gap-6 mb-4 lg:flex-row lg:items-center">
//             <div>
//               <h3 className="mb-2 text-xl font-semibold text-gray-700">🔍 Filter Leave Requests</h3>
//               <p className="text-gray-500">Search and filter by various criteria</p>
//             </div>

//             <div className="flex flex-col gap-3 sm:flex-row">
//               <button
//                 onClick={downloadCSV}
//                 className="flex items-center gap-2 px-6 py-3 font-semibold text-gray-900 transition shadow-lg bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl hover:from-green-600 hover:to-emerald-700"
//               >
//                 <FaDownload className="text-sm" />
//                 Download CSV
//               </button>

//               <button
//                 onClick={clearFilters}
//                 className="flex items-center gap-2 px-6 py-3 font-semibold text-gray-900 transition bg-gradient-to-r from-gray-500 to-gray-600 rounded-xl hover:from-gray-600 hover:to-gray-700"
//               >
//                 <FaFilter className="text-sm" />
//                 Clear Filters
//               </button>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
//             {/* Search */}
//             <div>
//               <label className="block mb-2 text-sm font-semibold text-blue-700">
//                 <FaSearch className="inline mr-2" />
//                 Search
//               </label>
//               <input
//                 type="text"
//                 placeholder="Search by name, ID, type, or reason..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full p-3 transition border-2 border-blue-200 rounded-xl focus:outline-none focus:border-blue-500"
//               />
//             </div>

//             {/* Status Filter */}
//             <div>
//               <label className="block mb-2 text-sm font-semibold text-purple-700">
//                 📊 Status Filter
//               </label>
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 className="w-full p-3 transition border-2 border-purple-200 rounded-xl focus:outline-none focus:border-purple-500"
//               >
//                 <option value="all">All Status</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="rejected">Rejected</option>
//               </select>
//             </div>

//             {/* Leave Type Filter */}
//             <div>
//               <label className="block mb-2 text-sm font-semibold text-green-700">
//                 🏷️ Leave Type
//               </label>
//               <select
//                 value={leaveTypeFilter}
//                 onChange={(e) => setLeaveTypeFilter(e.target.value)}
//                 className="w-full p-3 transition border-2 border-green-200 rounded-xl focus:outline-none focus:border-green-500"
//               >
//                 <option value="all">All Types</option>
//                 {leaveTypes.map(type => (
//                   <option key={type} value={type}>{type}</option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Results Count */}
//           <div className="flex items-center justify-between mt-4 text-sm">
//             <span className="font-semibold text-blue-700">
//               Showing <strong>{filteredLeaves.length}</strong> of <strong>{leaves.length}</strong> requests
//             </span>
//             {(searchTerm || statusFilter !== "all" || leaveTypeFilter !== "all") && (
//               <span className="font-semibold text-orange-600">
//                 🔍 Filters applied
//               </span>
//             )}
//           </div>
//         </div>

//         {/* Table Section */}
//         <div className="overflow-hidden bg-white border border-gray-200 shadow-lg rounded-2xl">
//           {filteredLeaves.length === 0 ? (
//             <div className="py-16 text-center">
//               <div className="mb-4 text-6xl">📭</div>
//               <p className="mb-4 text-lg font-semibold text-gray-500">
//                 {leaves.length === 0 ? "No leave requests found." : "No requests match your filters."}
//               </p>
//               {leaves.length > 0 && (
//                 <button
//                   onClick={clearFilters}
//                   className="px-6 py-2 font-semibold text-gray-900 transition bg-blue-600 rounded-lg hover:bg-blue-700"
//                 >
//                   🔄 Clear Filters
//                 </button>
//               )}
//             </div>
//           ) : (
//             <>
//               <div className="overflow-x-auto">
//                 <table className="w-full text-sm">
//                   <thead className="text-gray-900 bg-gradient-to-r from-purple-500 to-blue-600">
//                     <tr>
//                       <th className="px-6 py-4 font-semibold text-left">Employee</th>
//                       <th className="px-6 py-4 font-semibold text-left">Leave Type</th>
//                       <th className="px-6 py-4 font-semibold text-left">Date Range</th>
//                       <th className="px-6 py-4 font-semibold text-left">Days</th>
//                       <th className="px-6 py-4 font-semibold text-left">Reason</th>
//                       <th className="px-6 py-4 font-semibold text-left">Status</th>
//                       <th className="px-6 py-4 font-semibold text-left">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentPageLeaves.map((leave, idx) => (
//                       <tr
//                         key={leave._id}
//                         className={`border-t transition-all duration-200 ${
//                           idx % 2 === 0 ? "bg-white" : "bg-white"
//                         } hover:bg-purple-50 hover:shadow-sm`}
//                       >
//                         <td className="px-6 py-4">
//                           <div>
//                             <div className="font-semibold text-gray-900">{leave.employeeName}</div>
//                             {leave.employeeId && (
//                               <div className="text-xs text-gray-500">ID: {leave.employeeId}</div>
//                             )}
//                             <div className="text-xs text-gray-500">
//                               {new Date(leave.createdAt || leave.startDate).toLocaleDateString()}
//                             </div>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4">
//                           <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize ${getLeaveTypeClass(leave.leaveType)}`}>
//                             {leave.leaveType}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4">
//                           <div className="space-y-1">
//                             <div className="font-medium">
//                               {new Date(leave.startDate).toLocaleDateString()}
//                             </div>
//                             <div className="text-xs text-gray-500">to</div>
//                             <div className="font-medium">
//                               {new Date(leave.endDate).toLocaleDateString()}
//                             </div>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4">
//                           <span className="px-3 py-1 text-sm font-bold text-blue-800 bg-blue-100 rounded-full">
//                             {leave.days} day{leave.days !== 1 ? 's' : ''}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4">
//                           <div className="max-w-[200px]">
//                             <p className="text-gray-700 line-clamp-2">{leave.reason}</p>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4">
//                           <span className={`px-3 py-2 rounded-full text-xs font-semibold flex items-center gap-2 w-fit ${getStatusClass(leave.status)}`}>
//                             <span className="text-sm">{getStatusIcon(leave.status)}</span>
//                             <span className="capitalize">{leave.status}</span>
//                           </span>
//                         </td>
//                         <td className="px-6 py-4">
//                           <button
//                             onClick={() => handleEdit(leave)}
//                             className="flex items-center gap-2 px-4 py-2 font-semibold text-gray-900 transition shadow-lg bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl hover:from-blue-600 hover:to-purple-700"
//                           >
//                             <FaEdit className="text-sm" />
//                             Edit
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="flex flex-col items-center justify-between gap-4 p-6 border-t sm:flex-row bg-white">
//                   <div className="text-sm text-gray-500">
//                     Showing <strong>{(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, filteredLeaves.length)}</strong> of{" "}
//                     <strong>{filteredLeaves.length}</strong> requests
//                   </div>

//                   <div className="flex items-center gap-2">
//                     {/* Previous Button */}
//                     <button
//                       onClick={prevPage}
//                       disabled={currentPage === 1}
//                       className={`p-2 rounded-lg transition ${
//                         currentPage === 1
//                           ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           : "bg-blue-600 text-gray-900 hover:bg-blue-700 shadow-lg"
//                       }`}
//                     >
//                       <FaChevronLeft className="text-sm" />
//                     </button>

//                     {/* Page Numbers */}
//                     <div className="flex gap-1">
//                       {getPageNumbers().map(pageNumber => (
//                         <button
//                           key={pageNumber}
//                           onClick={() => goToPage(pageNumber)}
//                           className={`px-3 py-2 rounded-lg transition font-semibold ${
//                             currentPage === pageNumber
//                               ? "bg-gradient-to-r from-purple-600 to-blue-600 text-gray-900 shadow-lg"
//                               : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                           }`}
//                         >
//                           {pageNumber}
//                         </button>
//                       ))}
//                     </div>

//                     {/* Next Button */}
//                     <button
//                       onClick={nextPage}
//                       disabled={currentPage === totalPages}
//                       className={`p-2 rounded-lg transition ${
//                         currentPage === totalPages
//                           ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           : "bg-blue-600 text-gray-900 hover:bg-blue-700 shadow-lg"
//                       }`}
//                     >
//                       <FaChevronRight className="text-sm" />
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Edit Modal */}
//       {editingRecord && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-white ">
//           <div className="relative w-full max-w-md p-8 bg-white border border-purple-200 shadow-2xl rounded-2xl">
//             <button
//               onClick={() => setEditingRecord(null)}
//               className="absolute text-xl text-gray-500 transition top-4 right-4 hover:text-gray-500"
//             >
//               <FaTimes />
//             </button>

//             <div className="mb-6 text-center">
//               <h2 className="mb-2 text-2xl font-bold text-gray-700">Update Leave Status</h2>
//               <p className="text-gray-500">Change the status of this leave request</p>
//             </div>

//             <div className="mb-6 space-y-4">
//               <div className="p-4 bg-white rounded-xl">
//                 <p className="font-semibold text-gray-700">{editingRecord.employeeName}</p>
//                 <p className="text-sm text-gray-500 capitalize">{editingRecord.leaveType}</p>
//                 <p className="text-xs text-gray-500">
//                   {new Date(editingRecord.startDate).toLocaleDateString()} - {new Date(editingRecord.endDate).toLocaleDateString()}
//                 </p>
//               </div>

//               <div>
//                 <label className="block mb-2 text-sm font-semibold text-gray-700">
//                   New Status
//                 </label>
//                 <select
//                   value={updatedStatus}
//                   onChange={(e) => setUpdatedStatus(e.target.value)}
//                   className="w-full p-3 transition border-2 border-purple-200 rounded-xl focus:outline-none focus:border-purple-500"
//                 >
//                   <option value="pending">⏳ Pending</option>
//                   <option value="approved">✅ Approved</option>
//                   <option value="rejected">❌ Rejected</option>
//                 </select>
//               </div>

//               <div className={`p-3 rounded-xl text-center ${getStatusClass(updatedStatus)}`}>
//                 <span className="font-semibold capitalize">Current: {updatedStatus}</span>
//               </div>
//             </div>

//             <div className="flex gap-3">
//               <button
//                 onClick={() => setEditingRecord(null)}
//                 className="flex-1 px-4 py-3 font-semibold text-gray-900 transition bg-white0 rounded-xl hover:bg-gray-600"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleUpdateStatus}
//                 className="flex-1 px-4 py-3 font-semibold text-gray-900 transition shadow-lg bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl hover:from-green-600 hover:to-emerald-700"
//               >
//                 Update Status
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeavesList;

// import axios from "axios";
// import { useEffect, useState } from "react";
// import {
//   FaCalendarAlt,
//   FaSearch,
// } from "react-icons/fa";

// const LeavesList = () => {
//   const [leaves, setLeaves] = useState([]);
//   const [filteredLeaves, setFilteredLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");
//   const [startDateFilter, setStartDateFilter] = useState("");
//   const [endDateFilter, setEndDateFilter] = useState("");

//   // Fetch Leaves
//   const fetchLeaves = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get("https://api.timelyhealth.in/api/leaves/leaves");
//       const leavesData = res.data.records || res.data || [];
//       const sorted = leavesData.sort(
//         (a, b) => new Date(b.createdAt || b.startDate) - new Date(a.createdAt || a.startDate)
//       );
//       setLeaves(sorted);
//       setFilteredLeaves(sorted);
//     } catch (err) {
//       console.error("Failed to fetch leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   // ✅ Apply Filters
//   useEffect(() => {
//     let filtered = [...leaves];

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (l) =>
//           l.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.reason?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (statusFilter !== "all") {
//       filtered = filtered.filter((l) => l.status === statusFilter);
//     }

//     if (leaveTypeFilter !== "all") {
//       filtered = filtered.filter((l) => l.leaveType === leaveTypeFilter);
//     }

//     // ✅ Fixed Date Range Filter
//     if (startDateFilter) {
//       const start = new Date(startDateFilter);
//       filtered = filtered.filter((l) => new Date(l.startDate) >= start);
//     }

//     if (endDateFilter) {
//       const end = new Date(endDateFilter);
//       filtered = filtered.filter((l) => new Date(l.endDate) <= end);
//     }

//     setFilteredLeaves(filtered);
//   }, [searchTerm, statusFilter, leaveTypeFilter, startDateFilter, endDateFilter, leaves]);

//   const clearFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("all");
//     setLeaveTypeFilter("all");
//     setStartDateFilter("");
//     setEndDateFilter("");
//   };

//   // ✅ Small Stat Boxes
//   const StatCard = ({ label, value, color }) => (
//     <div className={`bg-white rounded-lg p-3 shadow-sm border-t-4 ${color} text-center`}>
//       <div className="text-lg font-bold">{value}</div>
//       <div className="text-xs font-medium text-gray-700">{label}</div>
//     </div>
//   );

//   const leaveTypes = [...new Set(leaves.map((l) => l.leaveType).filter(Boolean))];

//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-50 to-blue-100">
//         <div className="text-center">
//           <div className="w-12 h-12 mx-auto mb-3 border-b-2 border-purple-600 rounded-full animate-spin"></div>
//           <p className="font-semibold text-gray-500">Loading leave requests...</p>
//         </div>
//       </div>
//     );

//   return (
//     <div className="min-h-screen px-3 py-6 bg-gradient-to-br from-purple-50 to-blue-100">
//       <div className="mx-auto max-w-7xl">
//         {/* Header */}
//         <div className="mb-6 text-center">
//           <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
//             📋 Leave Requests
//           </h1>
//           <p className="text-sm text-gray-500">Manage and filter employee leave requests easily</p>
//         </div>

//         {/* ✅ Compact Stats */}
//         <div className="grid grid-cols-2 gap-2 mb-4 sm:grid-cols-4">
//           <StatCard label="Total Requests" value={leaves.length} color="border-purple-500" />
//           <StatCard
//             label="Pending"
//             value={leaves.filter((l) => l.status === "pending").length}
//             color="border-yellow-500"
//           />
//           <StatCard
//             label="Approved"
//             value={leaves.filter((l) => l.status === "approved").length}
//             color="border-green-500"
//           />
//           <StatCard
//             label="Rejected"
//             value={leaves.filter((l) => l.status === "rejected").length}
//             color="border-red-500"
//           />
//         </div>

//         {/* ✅ Filters Section */}
//         <div className="p-5 mb-6 bg-white border border-gray-200 shadow-md rounded-xl">
//           <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5">
//             {/* Search */}
//             <div>
//               <label className="block mb-1 text-xs font-semibold text-gray-500">
//                 <FaSearch className="inline mr-1" /> Search
//               </label>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full p-2 text-sm border border-gray-300 rounded-md"
//                 placeholder="Name / ID / Type / Reason"
//               />
//             </div>

//             {/* Status Filter */}
//             <div>
//               <label className="block mb-1 text-xs font-semibold text-gray-500">Status</label>
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 className="w-full p-2 text-sm border border-gray-300 rounded-md"
//               >
//                 <option value="all">All</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="rejected">Rejected</option>
//               </select>
//             </div>

//             {/* Leave Type */}
//             <div>
//               <label className="block mb-1 text-xs font-semibold text-gray-500">Leave Type</label>
//               <select
//                 value={leaveTypeFilter}
//                 onChange={(e) => setLeaveTypeFilter(e.target.value)}
//                 className="w-full p-2 text-sm border border-gray-300 rounded-md"
//               >
//                 <option value="all">All</option>
//                 {leaveTypes.map((t) => (
//                   <option key={t}>{t}</option>
//                 ))}
//               </select>
//             </div>

//             {/* ✅ Start Date */}
//             <div>
//               <label className="block mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> From
//               </label>
//               <input
//                 type="date"
//                 value={startDateFilter}
//                 onChange={(e) => setStartDateFilter(e.target.value)}
//                 className="w-full p-2 text-sm border border-gray-300 rounded-md"
//               />
//             </div>

//             {/* ✅ End Date */}
//             <div>
//               <label className="block mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> To
//               </label>
//               <input
//                 type="date"
//                 value={endDateFilter}
//                 onChange={(e) => setEndDateFilter(e.target.value)}
//                 className="w-full p-2 text-sm border border-gray-300 rounded-md"
//               />
//             </div>
//           </div>

//           <div className="flex justify-end gap-3 mt-4">
//             <button
//               onClick={clearFilters}
//               className="px-4 py-2 text-sm text-gray-900 transition bg-white0 rounded-md hover:bg-gray-600"
//             >
//               Clear Filters
//             </button>
//           </div>
//         </div>

//         {/* ✅ Table (Your Existing Table Design Below) */}
//         <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//           <table className="min-w-full">
//             <thead className="text-left text-gray-900 bg-gradient-to-r from-purple-500 to-blue-600">
//               <tr>
//                 <th className="px-4 py-3 rounded-tl-lg">Employee</th>
//                 <th className="px-4 py-3">Leave Type</th>
//                 <th className="px-4 py-3">Date Range</th>
//                 <th className="px-4 py-3">Days</th>
//                 <th className="px-4 py-3">Reason</th>
//                 <th className="px-4 py-3">Status</th>
//                 <th className="px-4 py-3 rounded-tr-lg">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredLeaves.length > 0 ? (
//                 filteredLeaves.map((l) => (
//                   <tr key={l._id} className="transition border-b hover:bg-white">
//                     <td className="px-4 py-3">
//                       <div className="font-semibold">{l.employeeName}</div>
//                       <div className="text-xs text-gray-500">
//                         ID: {l.employeeId}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {new Date(l.createdAt).toLocaleDateString()}
//                       </div>
//                     </td>
//                     <td className="px-4 py-3">
//                       <span className="px-3 py-1 text-xs text-gray-700 bg-gray-100 rounded-full">
//                         {l.leaveType || "Enter Leave Type"}
//                       </span>
//                     </td>
//                     <td className="px-4 py-3 text-sm text-gray-500">
//                       {new Date(l.startDate).toLocaleDateString()} <br />
//                       <span className="text-xs text-gray-500">to</span> <br />
//                       {new Date(l.endDate).toLocaleDateString()}
//                     </td>
//                     <td className="px-4 py-3">
//                       <span className="px-3 py-1 text-xs text-blue-700 bg-blue-100 rounded-full">
//                         {l.days} days
//                       </span>
//                     </td>
//                     <td className="px-4 py-3 text-sm text-gray-700">{l.reason}</td>
//                     <td className="px-4 py-3">
//                       {l.status === "approved" && (
//                         <span className="px-3 py-1 text-xs text-green-700 bg-blue-100 rounded-full">
//                           ✅ Approved
//                         </span>
//                       )}
//                       {l.status === "pending" && (
//                         <span className="px-3 py-1 text-xs text-yellow-700 bg-yellow-100 rounded-full">
//                           ⏳ Pending
//                         </span>
//                       )}
//                       {l.status === "rejected" && (
//                         <span className="px-3 py-1 text-xs text-red-700 bg-red-100 rounded-full">
//                           ❌ Rejected
//                         </span>
//                       )}
//                     </td>
//                     <td className="px-4 py-3 text-right">
//                       <button className="bg-gradient-to-r from-purple-500 to-blue-600 text-gray-900 px-4 py-1.5 rounded-md text-sm shadow hover:opacity-90 transition">
//                         ✏️ Edit
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="py-6 text-center text-gray-500">
//                     No leave records found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeavesList;




// import axios from "axios";
// import { useEffect, useState } from "react";
// import { FaCalendarAlt, FaSearch } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../config";

// const LeavesList = () => {
//   const [leaves, setLeaves] = useState([]);
//   const [filteredLeaves, setFilteredLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");
//   const [startDateFilter, setStartDateFilter] = useState("");
//   const [endDateFilter, setEndDateFilter] = useState("");

//   // https://api.timelyhealth.in

//   // ✅ Fetch all leaves
//   const fetchLeaves = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${API_BASE_URL}/leaves/leaves`
//       );
//       const leavesData = res.data.records || res.data || [];
//       const sorted = leavesData.sort(
//         (a, b) =>
//           new Date(b.createdAt || b.startDate) -
//           new Date(a.createdAt || a.startDate)
//       );
//       setLeaves(sorted);
//       setFilteredLeaves(sorted);
//     } catch (err) {
//       console.error("Failed to fetch leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   // ✅ Update Leave Status (Approve / Reject)
//   const updateLeaveStatus = async (id, status) => {
//     try {
//       // Get admin info from localStorage
//       const adminName = localStorage.getItem("adminName") || "Admin";
//       const adminEmail = localStorage.getItem("adminEmail") || "";

//       const res = await axios.put(
//         `${API_BASE_URL}/leaves/updateleaves/${id}`,
//         {
//           status,
//           adminName,
//           adminEmail
//         }
//       );

//       if (res.status === 200) {
//         alert(`Leave ${status} successfully`);
//         fetchLeaves(); // refresh table
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       alert("Failed to update leave status");
//     }
//   };

//   // ✅ Apply Filters
//   useEffect(() => {
//     let filtered = [...leaves];

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (l) =>
//           l.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.reason?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (statusFilter !== "all") {
//       filtered = filtered.filter((l) => l.status === statusFilter);
//     }

//     if (leaveTypeFilter !== "all") {
//       filtered = filtered.filter((l) => l.leaveType === leaveTypeFilter);
//     }

//     if (startDateFilter) {
//       const start = new Date(startDateFilter);
//       filtered = filtered.filter((l) => new Date(l.startDate) >= start);
//     }

//     if (endDateFilter) {
//       const end = new Date(endDateFilter);
//       filtered = filtered.filter((l) => new Date(l.endDate) <= end);
//     }

//     setFilteredLeaves(filtered);
//   }, [
//     searchTerm,
//     statusFilter,
//     leaveTypeFilter,
//     startDateFilter,
//     endDateFilter,
//     leaves,
//   ]);

//   // ✅ Clear Filters
//   const clearFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("all");
//     setLeaveTypeFilter("all");
//     setStartDateFilter("");
//     setEndDateFilter("");
//   };
//   const navigate = useNavigate();
//   // ✅ Stat Box
//   const StatCard = ({ label, value, color }) => (
//     <div
//       className={`bg-white rounded-lg p-3 shadow-sm border-t-4 ${color} text-center`}
//     >
//       <div className="text-lg font-bold">{value}</div>
//       <div className="text-xs font-medium text-gray-700">{label}</div>
//     </div>
//   );

//   const leaveTypes = [...new Set(leaves.map((l) => l.leaveType).filter(Boolean))];


//   // ✅ Loading Screen
//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-50 to-blue-100">
//         <div className="text-center">
//           <div className="w-12 h-12 mx-auto mb-3 border-b-2 border-purple-600 rounded-full animate-spin"></div>
//           <p className="font-semibold text-gray-500">
//             Loading leave requests...
//           </p>
//         </div>
//       </div>
//     );

//   return (
//     <div className="min-h-screen px-3 py-6 bg-gradient-to-br from-purple-50 to-blue-100">
//       <div className="mx-auto max-w-9xl">
//         {/* Header */}
//         {/* <div className="relative flex items-center mb-6"> */}
//         {/* Center Title */}
//         {/* <div className="w-full text-center">
//     <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
//       📋 Leave Requests
//     </h1>
//     <p className="text-sm text-gray-500">
//       Manage and filter employee leave requests easily
//     </p>
//   </div> */}

//         {/* Right Button */}
//         {/* <button
//     onClick={() => navigate("/leaves-report")}
//     className="absolute right-0 px-4 py-2 text-sm text-gray-900 bg-blue-600 rounded-lg hover:bg-blue-700"
//   >
//     📊 Leaves Report
//   </button>
// </div> */}

//         {/* ✅ Stats */}
//         <div className="grid grid-cols-2 gap-2 mb-2 sm:grid-cols-4">
//           <StatCard
//             label={`Total Requests: ${leaves.length}`}
//             // value={leaves.length}
//             color="border-purple-500"
//           />
//           <StatCard
//             label={`Pending: ${leaves.filter((l) => l.status === "pending").length}`}
//             // value={leaves.filter((l) => l.status === "pending").length}
//             color="border-yellow-500"
//           />
//           <StatCard
//             label={`Approved: ${leaves.filter((l) => l.status === "approved").length}`}
//             // value={leaves.filter((l) => l.status === "approved").length}
//             color="border-green-500"
//           />
//           <StatCard
//             label={`Rejected: ${leaves.filter((l) => l.status === "rejected").length}`}
//             // value={leaves.filter((l) => l.status === "rejected").length}
//             color="border-red-500"
//           />
//         </div>




//         <div className="p-3 mb-3 bg-white border border-gray-200 shadow-md rounded-xl">

//           {/* Filters – Single Row */}
//           <div className="flex items-end gap-4 flex-nowrap">

//             {/* Search */}
//             <div className="flex flex-col w-64">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaSearch className="inline mr-1" /> Search
//               </label>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//                 placeholder="Name / ID / Type / Reason"
//               />
//             </div>

//             {/* Status */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 Status
//               </label>
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               >
//                 <option value="all">All</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="rejected">Rejected</option>
//               </select>
//             </div>

//             {/* From Date */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> From
//               </label>
//               <input
//                 type="date"
//                 value={startDateFilter}
//                 onChange={(e) => setStartDateFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               />
//             </div>

//             {/* To Date */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> To
//               </label>
//               <input
//                 type="date"
//                 value={endDateFilter}
//                 onChange={(e) => setEndDateFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               />
//             </div>

//             {/* Clear Button */}
//             <button
//               onClick={clearFilters}
//               className="h-9 px-5 mb-[2px] text-sm font-medium text-gray-900 bg-white0 rounded-md hover:bg-gray-600 transition"
//             >
//               Clear
//             </button>
//             <button onClick={() => navigate("/leaves-report")}

//               className="h-9 px-5 mb-[2px] text-sm font-medium text-gray-900 bg-white0 rounded-md hover:bg-gray-600 transition"
//             >
//               Leaves
//             </button>

//           </div>
//         </div>


//         {/* ✅ Table */}
//       <div className="mb-6 overflow-hidden bg-white rounded-lg shadow-lg">
//                 <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//                   <table className="min-w-full">
//                     <thead className="text-sm text-left text-gray-900 bg-gradient-to-r from-green-500 to-blue-600">
//               <tr>
//                 <th className="py-2 text-center ">Name</th>
//                 {/* <th className="py-2 text-center">Leave Type</th> */}
//                 <th className="py-2 text-center">Dates</th>
//                 <th className="py-2 text-center">Days</th>
//                 <th className="py-2 text-center">Reason</th>
//                 <th className="py-2 text-center">Status</th>
//                 <th className="py-2 text-center rounded-tr-lg">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredLeaves.length > 0 ? (
//                 filteredLeaves.map((l) => (
//                   <tr
//                     key={l._id}
//                     className="transition border-b hover:bg-white"
//                   >
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                       <div className="font-semibold">{l.employeeName}</div>
//                       {/* <div className="text-xs text-gray-500">
//                         ID: {l.employeeId}
//                       </div> */}
//                       {/* <div className="text-xs text-gray-500">
//                         {new Date(l.createdAt).toLocaleDateString()}
//                       </div> */}
//                     </td>
//                     {/* <td className="px-4 py-2">
//                       <span className="px-2 py-1 text-xs text-gray-700 bg-gray-100 rounded-full">
//                         {l.leaveType || "Enter Leave Type"}
//                       </span>
//                     </td> */}
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                       {new Date(l.startDate).toLocaleDateString()} <br />
//                       <span className="text-xs text-gray-500">to</span> <br />
//                       {new Date(l.endDate).toLocaleDateString()}
//                     </td>
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                       <span className="px-2 py-2 text-xs text-center text-blue-700 bg-blue-100 rounded-full">
//                         {l.days} days
//                       </span>
//                     </td>
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-500 whitespace-nowrap">
//                       {l.reason}
//                     </td>
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                       {l.status === "approved" && (
//                         <span className="px-2 py-2 text-xs text-center text-green-700 bg-blue-100 rounded-full">
//                           ✅ Approved
//                         </span>
//                       )}
//                       {l.status === "pending" && (
//                         <span className="px-2 py-2 text-xs text-center text-yellow-700 bg-yellow-100 rounded-full">
//                           ⏳ Pending
//                         </span>
//                       )}
//                       {l.status === "rejected" && (
//                         <span className="px-2 py-2 text-xs text-center text-red-700 bg-red-100 rounded-full">
//                           ❌ Rejected
//                         </span>
//                       )}
//                     </td>

//                     {/* ✅ Approve / Reject Buttons */}
//                     <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                       {l.status === "pending" ? (
//                         <div className="flex justify-end gap-2">
//                           <button
//                             onClick={() => updateLeaveStatus(l._id, "approved")}
//                             className="px-2 py-2 text-xs text-center text-gray-900 transition bg-blue-600 rounded-md hover:bg-blue-600"
//                           >
//                             ✅ Approve
//                           </button>
//                           <button
//                             onClick={() => updateLeaveStatus(l._id, "rejected")}
//                             className="px-2 py-2 text-xs text-center text-gray-900 transition bg-red-500 rounded-md hover:bg-red-600"
//                           >
//                             ❌ Reject
//                           </button>
//                         </div>
//                       ) : (
//                         <span className="text-xs italic text-gray-500">
//                           No actions
//                         </span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="py-6 text-center text-gray-500">
//                     No leave records found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//     </div>

//   );
// };

// export default LeavesList;


// import axios from "axios";
// import { useEffect, useState } from "react";
// import { FaCalendarAlt, FaSearch } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../config";

// const LeavesList = () => {
//   const [leaves, setLeaves] = useState([]);
//   const [filteredLeaves, setFilteredLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");
//   const [startDateFilter, setStartDateFilter] = useState("");
//   const [endDateFilter, setEndDateFilter] = useState("");

//   // ✅ Fetch all leaves
//   const fetchLeaves = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${API_BASE_URL}/leaves/leaves`
//       );
//       const leavesData = res.data.records || res.data || [];
//       const sorted = leavesData.sort(
//         (a, b) =>
//           new Date(b.createdAt || b.startDate) -
//           new Date(a.createdAt || a.startDate)
//       );
//       setLeaves(sorted);
//       setFilteredLeaves(sorted);
//       setCurrentPage(1); // Reset to first page on new data
//     } catch (err) {
//       console.error("Failed to fetch leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   // ✅ Update Leave Status (Approve / Reject)
//   const updateLeaveStatus = async (id, status) => {
//     try {
//       // Get admin info from localStorage
//       const adminName = localStorage.getItem("adminName") || "Admin";
//       const adminEmail = localStorage.getItem("adminEmail") || "";

//       const res = await axios.put(
//         `${API_BASE_URL}/leaves/updateleaves/${id}`,
//         {
//           status,
//           adminName,
//           adminEmail
//         }
//       );

//       if (res.status === 200) {
//         alert(`Leave ${status} successfully`);
//         fetchLeaves(); // refresh table
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       alert("Failed to update leave status");
//     }
//   };

//   // ✅ Apply Filters
//   useEffect(() => {
//     let filtered = [...leaves];

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (l) =>
//           l.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.reason?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (statusFilter !== "all") {
//       filtered = filtered.filter((l) => l.status === statusFilter);
//     }

//     if (leaveTypeFilter !== "all") {
//       filtered = filtered.filter((l) => l.leaveType === leaveTypeFilter);
//     }

//     if (startDateFilter) {
//       const start = new Date(startDateFilter);
//       filtered = filtered.filter((l) => new Date(l.startDate) >= start);
//     }

//     if (endDateFilter) {
//       const end = new Date(endDateFilter);
//       filtered = filtered.filter((l) => new Date(l.endDate) <= end);
//     }

//     setFilteredLeaves(filtered);
//     setCurrentPage(1); // Reset to first page on filter change
//   }, [
//     searchTerm,
//     statusFilter,
//     leaveTypeFilter,
//     startDateFilter,
//     endDateFilter,
//     leaves,
//   ]);

//   // ✅ Clear Filters
//   const clearFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("all");
//     setLeaveTypeFilter("all");
//     setStartDateFilter("");
//     setEndDateFilter("");
//   };

//   const navigate = useNavigate();

//   // ✅ Pagination Handlers
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1); // Reset to first page
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };

//   const handlePageClick = (page) => {
//     setCurrentPage(page);
//   };

//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= totalPages; i++) {
//       if (
//         i === 1 ||
//         i === totalPages ||
//         (i >= currentPage - 2 && i <= currentPage + 2)
//       ) {
//         pageNumbers.push(i);
//       } else if (i === currentPage - 3 || i === currentPage + 3) {
//         pageNumbers.push("...");
//       }
//     }
//     return pageNumbers;
//   };

//   // Calculate pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLeaves.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

//   // ✅ Stat Box
//   const StatCard = ({ label, value, color }) => (
//     <div
//       className={`bg-white rounded-lg p-3 shadow-sm border-t-4 ${color} text-center`}
//     >
//       <div className="text-lg font-bold">{value}</div>
//       <div className="text-xs font-medium text-gray-700">{label}</div>
//     </div>
//   );

//   // ✅ Loading Screen
//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-50 to-blue-100">
//         <div className="text-center">
//           <div className="w-12 h-12 mx-auto mb-3 border-b-2 border-purple-600 rounded-full animate-spin"></div>
//           <p className="font-semibold text-gray-500">
//             Loading leave requests...
//           </p>
//         </div>
//       </div>
//     );

//   return (
//     <div className="min-h-screen px-2 py-2 bg-gradient-to-br from-purple-50 to-blue-100">
//       <div className="mx-auto max-w-9xl">
//         {/* ✅ Stats */}
//        <div className="grid grid-cols-2 gap-2 mb-2 sm:grid-cols-4">
//         <StatCard
//            label={`Total Requests: ${leaves.length}`}
//            // value={leaves.length}
//            color="border-purple-500"
//          />
//          <StatCard
//            label={`Pending: ${leaves.filter((l) => l.status === "pending").length}`}
//            // value={leaves.filter((l) => l.status === "pending").length}
//             color="border-yellow-500"
//           />
//           <StatCard
//             label={`Approved: ${leaves.filter((l) => l.status === "approved").length}`}
//             // value={leaves.filter((l) => l.status === "approved").length}
//             color="border-green-500"
//           />
//          <StatCard
//             label={`Rejected: ${leaves.filter((l) => l.status === "rejected").length}`}
//             // value={leaves.filter((l) => l.status === "rejected").length}
//             color="border-red-500"
//           />
//          </div>

//         <div className="p-2 mb-2 bg-white border border-gray-200 shadow-md rounded-xl">
//           {/* Filters – Single Row */}
//           <div className="flex items-end gap-4 flex-nowrap">
//             {/* Search */}
//             <div className="flex flex-col w-64">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaSearch className="inline mr-1" /> Search
//               </label>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//                 placeholder="Name / ID / Type / Reason"
//               />
//             </div>

//             {/* Status */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 Status
//               </label>
//               <select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               >
//                 <option value="all">All</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="rejected">Rejected</option>
//               </select>
//             </div>

//             {/* From Date */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> From
//               </label>
//               <input
//                 type="date"
//                 value={startDateFilter}
//                 onChange={(e) => setStartDateFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               />
//             </div>

//             {/* To Date */}
//             <div className="flex flex-col w-40">
//               <label className="mb-1 text-xs font-semibold text-gray-500">
//                 <FaCalendarAlt className="inline mr-1 text-gray-500" /> To
//               </label>
//               <input
//                 type="date"
//                 value={endDateFilter}
//                 onChange={(e) => setEndDateFilter(e.target.value)}
//                 className="px-3 text-sm border border-gray-300 rounded-md h-9 focus:outline-none focus:ring-1 focus:ring-blue-500"
//               />
//             </div>

//             {/* Clear Button */}
//             <button
//               onClick={clearFilters}
//               className="h-9 px-5 mb-[2px] text-sm font-medium text-gray-900 bg-white0 rounded-md hover:bg-gray-600 transition"
//             >
//               Clear
//             </button>
//             <button 
//               onClick={() => navigate("/leaves-report")}
//               className="h-9 px-5 mb-[2px] text-sm font-medium text-gray-900 bg-blue-600 rounded-md hover:bg-blue-700 transition"
//             >
//               📊 Report
//             </button>
//           </div>
//         </div>

//         {/* ✅ Table */}
//         <div className="mb-6 overflow-hidden bg-white rounded-lg shadow-lg">
//           <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//             <table className="min-w-full">
//               <thead className="text-sm text-left text-gray-900 bg-gradient-to-r from-green-500 to-blue-600">
//                 <tr>
//                   <th className="px-2 py-2 text-center">Employee ID</th>
//                   <th className="px-2 py-2 text-center">Name</th>
//                   <th className="px-2 py-2 text-center">Dates</th>
//                   <th className="px-2 py-2 text-center">Days</th>
//                   <th className="px-2 py-2 text-center">Reason</th>
//                   <th className="px-2 py-2 text-center">Status</th>
//                   <th className="px-2 py-2 text-center rounded-tr-lg">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((l) => (
//                     <tr
//                       key={l._id}
//                       className="transition border-b hover:bg-white"
//                     >
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         {l.employeeId || "N/A"}
//                       </td>
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         <div className="font-semibold">{l.employeeName}</div>
//                       </td>
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         {new Date(l.startDate).toLocaleDateString()} <br />
//                         <span className="text-xs text-gray-500">to</span> <br />
//                         {new Date(l.endDate).toLocaleDateString()}
//                       </td>
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         <span className="px-2 py-2 text-xs text-center text-blue-700 bg-blue-100 rounded-full">
//                           {l.days} {l.days === 1 ? 'day' : 'days'}
//                         </span>
//                       </td>
//                       <td className="max-w-xs px-2 py-2 text-sm font-medium text-center text-gray-500 truncate whitespace-nowrap">
//                         {l.reason}
//                       </td>
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         {l.status === "approved" && (
//                           <span className="px-2 py-2 text-xs text-center text-green-700 bg-blue-100 rounded-full">
//                             ✅ Approved
//                           </span>
//                         )}
//                         {l.status === "pending" && (
//                           <span className="px-2 py-2 text-xs text-center text-yellow-700 bg-yellow-100 rounded-full">
//                             ⏳ Pending
//                           </span>
//                         )}
//                         {l.status === "rejected" && (
//                           <span className="px-2 py-2 text-xs text-center text-red-700 bg-red-100 rounded-full">
//                             ❌ Rejected
//                           </span>
//                         )}
//                       </td>
//                       <td className="px-2 py-2 text-sm font-medium text-center text-gray-900 whitespace-nowrap">
//                         {l.status === "pending" ? (
//                           <div className="flex justify-center gap-2">
//                             <button
//                               onClick={() => updateLeaveStatus(l._id, "approved")}
//                               className="px-2 py-2 text-xs text-center text-gray-900 transition bg-blue-600 rounded-md hover:bg-blue-600"
//                             >
//                               Approve
//                             </button>
//                             <button
//                               onClick={() => updateLeaveStatus(l._id, "rejected")}
//                               className="px-2 py-2 text-xs text-center text-gray-900 transition bg-red-500 rounded-md hover:bg-red-600"
//                             >
//                               Reject
//                             </button>
//                           </div>
//                         ) : (
//                           <span className="text-xs italic text-gray-500">
//                             No actions
//                           </span>
//                         )}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="7" className="py-6 text-center text-gray-500">
//                       No leave records found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ✅ Pagination Section - Added exactly as requested */}
//         {filteredLeaves.length > 0 && (
//           <div className="flex flex-col items-center justify-between gap-4 mt-6 sm:flex-row">
//             {/* Show entries dropdown */}
//             <div className="flex flex-wrap items-center gap-4">
//               <div className="flex items-center gap-2">
//                 <label className="text-sm font-medium text-gray-700">
//                   Show:
//                 </label>
//                 <select
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                   className="p-2 text-sm border rounded-lg"
//                 >
//                   <option value={5}>5</option>
//                   <option value={10}>10</option>
//                   <option value={20}>20</option>
//                   <option value={50}>50</option>
//                 </select>
//                 <span className="text-sm text-gray-500">entries</span>
//               </div>
//             </div>

//             {/* Pagination buttons */}
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 1}
//                 className={`px-4 py-1 text-sm border rounded-lg ${
//                   currentPage === 1
//                     ? "text-gray-500 bg-gray-100 cursor-not-allowed"
//                     : "text-blue-600 bg-white hover:bg-blue-50 border-blue-200"
//                 }`}
//               >
//                 Previous
//               </button>

//               {getPageNumbers().map((page, index) => (
//                 <button
//                   key={index}
//                   onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                   disabled={page === "..."}
//                   className={`px-4 py-1 text-sm border rounded-lg ${
//                     page === "..."
//                       ? "text-gray-500 bg-white cursor-default"
//                       : currentPage === page
//                       ? "text-gray-900 bg-blue-600 border-blue-600"
//                       : "text-blue-600 bg-white hover:bg-blue-50 border-blue-300"
//                   }`}
//                 >
//                   {page}
//                 </button>
//               ))}

//               <button
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//                 className={`px-4 py-1 text-sm border rounded-lg ${
//                   currentPage === totalPages
//                     ? "text-gray-500 bg-gray-100 cursor-not-allowed"
//                     : "text-blue-600 bg-white hover:bg-blue-50 border-blue-300"
//                 }`}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {/* No records message */}
//         {filteredLeaves.length === 0 && (
//           <div className="py-8 text-center text-gray-500">
//             No records found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LeavesList;


// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import CountUp from "react-countup";
// import { FaBuilding, FaSearch, FaUserTag } from "react-icons/fa";
// import { FiCalendar, FiCheckCircle, FiClock, FiList, FiXCircle } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../config";
// import { isEmployeeHidden } from "../utils/employeeStatus";

// const LeavesList = () => {
//   const [leaves, setLeaves] = useState([]);
//   const [filteredLeaves, setFilteredLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Employees data for department/designation
//   const [employees, setEmployees] = useState([]);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");
//   const [startDateFilter, setStartDateFilter] = useState("");
//   const [endDateFilter, setEndDateFilter] = useState("");

//   // Department and Designation filter states
//   const [filterDepartment, setFilterDepartment] = useState("");
//   const [filterDesignation, setFilterDesignation] = useState("");
//   const [showDepartmentFilter, setShowDepartmentFilter] = useState(false);
//   const [showDesignationFilter, setShowDesignationFilter] = useState(false);

//   // Unique departments and designations
//   const [uniqueDepartments, setUniqueDepartments] = useState([]);
//   const [uniqueDesignations, setUniqueDesignations] = useState([]);

//   // Refs for click outside
//   const departmentFilterRef = useRef(null);
//   const designationFilterRef = useRef(null);

//   // Click outside handlers for filter dropdowns
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (departmentFilterRef.current && !departmentFilterRef.current.contains(event.target)) {
//         setShowDepartmentFilter(false);
//       }
//       if (designationFilterRef.current && !designationFilterRef.current.contains(event.target)) {
//         setShowDesignationFilter(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // ✅ Fetch all leaves and employees
//   const fetchLeaves = async () => {
//     try {
//       setLoading(true);
//       const [leavesRes, empRes] = await Promise.all([
//         axios.get(`${API_BASE_URL}/leaves/leaves`),
//         axios.get(`${API_BASE_URL}/employees/get-employees`)
//       ]);

//       const employeesData = empRes.data || [];
//       const activeEmployees = employeesData.filter(emp => !isEmployeeHidden(emp));
//       setEmployees(activeEmployees);

//       // Extract unique departments and designations
//       const depts = new Set();
//       const designations = new Set();
//       activeEmployees.forEach(emp => {
//         if (emp.department) depts.add(emp.department);
//         if (emp.role || emp.designation) designations.add(emp.role || emp.designation);
//       });
//       setUniqueDepartments(Array.from(depts).sort());
//       setUniqueDesignations(Array.from(designations).sort());

//       const leavesData = leavesRes.data.records || leavesRes.data || [];
//       const sorted = leavesData.sort(
//         (a, b) =>
//           new Date(b.createdAt || b.startDate) -
//           new Date(a.createdAt || a.startDate)
//       );

//       // Filter out leaves from hidden employees
//       const activeEmployeeIds = new Set(activeEmployees.map(emp => emp.employeeId || emp._id));
//       const filteredLeavesData = sorted.filter(leave =>
//         activeEmployeeIds.has(leave.employeeId)
//       );

//       setLeaves(filteredLeavesData);
//       setFilteredLeaves(filteredLeavesData);
//       setCurrentPage(1);
//     } catch (err) {
//       console.error("Failed to fetch leaves:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   // Get employee department and designation
//   const getEmployeeDetails = (employeeId) => {
//     const emp = employees.find(e => e.employeeId === employeeId || e._id === employeeId);
//     return {
//       department: emp?.department || emp?.departmentName || "N/A",
//       designation: emp?.designation || emp?.role || "N/A"
//     };
//   };

//   // ✅ Update Leave Status (Approve / Reject)
//   const updateLeaveStatus = async (id, status) => {
//     try {
//       const adminName = localStorage.getItem("adminName") || "Admin";
//       const adminEmail = localStorage.getItem("adminEmail") || "";

//       const res = await axios.put(
//         `${API_BASE_URL}/leaves/updateleaves/${id}`,
//         {
//           status,
//           adminName,
//           adminEmail
//         }
//       );

//       if (res.status === 200) {
//         alert(`Leave ${status} successfully`);
//         fetchLeaves();
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       alert("Failed to update leave status");
//     }
//   };

//   // ✅ Apply Filters
//   useEffect(() => {
//     let filtered = [...leaves];

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (l) =>
//           l.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           l.reason?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (statusFilter !== "all") {
//       filtered = filtered.filter((l) => l.status === statusFilter);
//     }

//     if (leaveTypeFilter !== "all") {
//       filtered = filtered.filter((l) => l.leaveType === leaveTypeFilter);
//     }

//     if (startDateFilter) {
//       const start = new Date(startDateFilter);
//       filtered = filtered.filter((l) => new Date(l.startDate) >= start);
//     }

//     if (endDateFilter) {
//       const end = new Date(endDateFilter);
//       filtered = filtered.filter((l) => new Date(l.endDate) <= end);
//     }

//     // Filter by Department
//     if (filterDepartment) {
//       filtered = filtered.filter(l => {
//         const empDetails = getEmployeeDetails(l.employeeId);
//         return empDetails.department === filterDepartment;
//       });
//     }

//     // Filter by Designation
//     if (filterDesignation) {
//       filtered = filtered.filter(l => {
//         const empDetails = getEmployeeDetails(l.employeeId);
//         return empDetails.designation === filterDesignation;
//       });
//     }

//     setFilteredLeaves(filtered);
//     setCurrentPage(1);
//   }, [
//     searchTerm,
//     statusFilter,
//     leaveTypeFilter,
//     startDateFilter,
//     endDateFilter,
//     filterDepartment,
//     filterDesignation,
//     leaves,
//   ]);

//   // ✅ Clear Filters
//   const clearFilters = () => {
//     setSearchTerm("");
//     setStatusFilter("all");
//     setLeaveTypeFilter("all");
//     setStartDateFilter("");
//     setEndDateFilter("");
//     setFilterDepartment("");
//     setFilterDesignation("");
//   };

//   const navigate = useNavigate();

//   // ✅ Pagination Handlers
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };

//   const handlePageClick = (page) => {
//     setCurrentPage(page);
//   };

//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= totalPages; i++) {
//       if (
//         i === 1 ||
//         i === totalPages ||
//         (i >= currentPage - 2 && i <= currentPage + 2)
//       ) {
//         pageNumbers.push(i);
//       } else if (i === currentPage - 3 || i === currentPage + 3) {
//         pageNumbers.push("...");
//       }
//     }
//     return pageNumbers;
//   };

//   // Calculate pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLeaves.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

//   // ✅ Stat Box - Matching the Dashboard design
//   const StatCard = ({ icon: Icon, label, value, color }) => (
//     <div className={`bg-white rounded-lg p-3 shadow-sm border-t-4 ${color} cursor-pointer hover:shadow-md transition-all duration-300 flex items-center justify-between`}>
//       <div className="flex items-center gap-2">
//         <Icon className="text-gray-500 text-base flex-shrink-0" />
//         <div className="text-sm font-medium text-gray-700">{label}</div>
//       </div>
//       <div className="text-sm font-bold text-gray-700">
//         <CountUp end={value} duration={2} separator="," />
//       </div>
//     </div>
//   );

//   // ✅ Loading Screen
//   if (loading)
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-50 to-blue-100">
//         <div className="text-center">
//           <div className="w-12 h-12 mx-auto mb-3 border-b-2 border-purple-600 rounded-full animate-spin"></div>
//           <p className="font-semibold text-gray-500">
//             Loading leave requests...
//           </p>
//         </div>
//       </div>
//     );

//   return (
//     <div className="min-h-screen px-2 py-2 bg-gradient-to-br from-purple-50 to-blue-100">
//       <div className="mx-auto max-w-9xl">
//         {/* ✅ Stats */}
//         <div className="grid grid-cols-2 gap-2 mb-2 sm:grid-cols-4">
//           <StatCard
//             icon={FiList}
//             label="Total Requests"
//             value={leaves.length}
//             color="border-purple-500"
//           />
//           <StatCard
//             icon={FiClock}
//             label="Pending"
//             value={leaves.filter((l) => l.status === "pending").length}
//             color="border-yellow-500"
//           />
//           <StatCard
//             icon={FiCheckCircle}
//             label="Approved"
//             value={leaves.filter((l) => l.status === "approved").length}
//             color="border-green-500"
//           />
//           <StatCard
//             icon={FiXCircle}
//             label="Rejected"
//             value={leaves.filter((l) => l.status === "rejected").length}
//             color="border-red-500"
//           />
//         </div>


//         {/* Filters Section */}
//         <div className="p-3 mb-3 bg-white rounded-lg shadow-md">
//           <div className="flex flex-wrap items-center gap-2">

//             {/* ID/Name Search */}
//             <div className="relative flex-1 min-w-[180px]">
//               <FaSearch className="absolute text-sm text-gray-500 transform -translate-y-1/2 left-2 top-1/2" />
//               <input
//                 type="text"
//                 placeholder="Search by ID or Name..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>

//             {/* Status Filter */}
//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="h-8 px-2 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 min-w-[100px]"
//             >
//               <option value="all">All Status</option>
//               <option value="pending">Pending</option>
//               <option value="approved">Approved</option>
//               <option value="rejected">Rejected</option>
//             </select>

//             {/* Leave Type Filter */}
//             <select
//               value={leaveTypeFilter}
//               onChange={(e) => setLeaveTypeFilter(e.target.value)}
//               className="h-8 px-2 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 min-w-[100px]"
//             >
//               <option value="all">All Types</option>
//               <option value="sick">Sick Leave</option>
//               <option value="casual">Casual Leave</option>
//               <option value="earned">Earned Leave</option>
//               <option value="other">Other</option>
//             </select>

//             {/* Department Filter Button */}
//             <div className="relative" ref={departmentFilterRef}>
//               <button
//                 onClick={() => setShowDepartmentFilter(!showDepartmentFilter)}
//                 className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${filterDepartment
//                     ? 'bg-blue-600 text-gray-900 hover:bg-blue-700'
//                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                   }`}
//               >
//                 <FaBuilding className="text-xs" /> Dept {filterDepartment && `: ${filterDepartment}`}
//               </button>

//               {/* Department Filter Dropdown */}
//               {showDepartmentFilter && (
//                 <div className="absolute z-50 w-48 mt-1 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg max-h-60">
//                   <div
//                     onClick={() => {
//                       setFilterDepartment('');
//                       setShowDepartmentFilter(false);
//                     }}
//                     className="px-3 py-2 text-xs font-medium text-gray-700 border-b border-gray-200 cursor-pointer hover:bg-blue-50"
//                   >
//                     All Departments
//                   </div>
//                   {uniqueDepartments.map(dept => (
//                     <div
//                       key={dept}
//                       onClick={() => {
//                         setFilterDepartment(dept);
//                         setShowDepartmentFilter(false);
//                       }}
//                       className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${filterDepartment === dept ? 'bg-blue-50 text-blue-700 font-medium' : ''
//                         }`}
//                     >
//                       {dept}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Designation Filter Button */}
//             <div className="relative" ref={designationFilterRef}>
//               <button
//                 onClick={() => setShowDesignationFilter(!showDesignationFilter)}
//                 className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${filterDesignation
//                     ? 'bg-blue-600 text-gray-900 hover:bg-blue-700'
//                     : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                   }`}
//               >
//                 <FaUserTag className="text-xs" /> Desig {filterDesignation && `: ${filterDesignation}`}
//               </button>

//               {/* Designation Filter Dropdown */}
//               {showDesignationFilter && (
//                 <div className="absolute z-50 w-48 mt-1 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg max-h-60">
//                   <div
//                     onClick={() => {
//                       setFilterDesignation('');
//                       setShowDesignationFilter(false);
//                     }}
//                     className="px-3 py-2 text-xs font-medium text-gray-700 border-b border-gray-200 cursor-pointer hover:bg-blue-50"
//                   >
//                     All Designations
//                   </div>
//                   {uniqueDesignations.map(des => (
//                     <div
//                       key={des}
//                       onClick={() => {
//                         setFilterDesignation(des);
//                         setShowDesignationFilter(false);
//                       }}
//                       className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${filterDesignation === des ? 'bg-blue-50 text-blue-700 font-medium' : ''
//                         }`}
//                     >
//                       {des}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* From Date */}
//             <div className="relative w-[130px]">
//               <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
//                 From:
//               </span>
//               <input
//                 type="date"
//                 value={startDateFilter}
//                 onChange={(e) => setStartDateFilter(e.target.value)}
//                 onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                 className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>

//             {/* To Date */}
//             <div className="relative w-[130px]">
//               <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
//                 To:
//               </span>
//               <input
//                 type="date"
//                 value={endDateFilter}
//                 onChange={(e) => setEndDateFilter(e.target.value)}
//                 onClick={(e) => e.target.showPicker && e.target.showPicker()}
//                 className="w-full pl-10 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>

//             {/* Clear Filters Button */}
//             {(searchTerm || filterDepartment || filterDesignation || statusFilter !== "all" || leaveTypeFilter !== "all" || startDateFilter || endDateFilter) && (
//               <button
//                 onClick={clearFilters}
//                 className="h-8 px-3 text-xs font-medium text-gray-500 transition bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
//               >
//                 Clear
//               </button>
//             )}

//             {/* Report Button */}
//             <button
//               onClick={() => navigate("/leaves-report")}
//               className="h-8 px-3 text-xs font-medium text-gray-900 transition bg-blue-600 rounded-md hover:bg-blue-700"
//             >
//               📊 Report
//             </button>
//           </div>
//         </div>

//         {/* ✅ Table */}
//         <div className="mb-6 overflow-hidden bg-white rounded-lg shadow-lg">
//           <div className="overflow-x-auto bg-white shadow-lg rounded-xl">
//             <table className="min-w-full">
//               <thead className="text-sm text-left text-gray-900 bg-gradient-to-r from-green-500 to-blue-600">
//                 <tr>
//                   <th className="py-2 text-center ">Employee ID</th>
//                   <th className="py-2 text-center ">Name</th>
//                   <th className="py-2 text-center ">Department</th>
//                   <th className="py-2 text-center ">Designation</th>
//                   <th className="py-2 text-center ">Dates</th>
//                   <th className="py-2 text-center ">Days</th>
//                   <th className="py-2 text-center ">Reason</th>
//                   <th className="py-2 text-center ">Status</th>
//                   <th className="py-2 text-center rounded-tr-lg ">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((l) => {
//                     const empDetails = getEmployeeDetails(l.employeeId);
//                     return (
//                       <tr
//                         key={l._id}
//                         className="transition border-b hover:bg-white"
//                       >
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           {l.employeeId || "N/A"}
//                         </td>
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           <div className="font-medium">{l.employeeName}</div>
//                         </td>
//                         <td className="px-2 py-2 text-center text-gray-500 ">
//                           {empDetails.department}
//                         </td>
//                         <td className="px-2 py-2 text-center text-gray-500 ">
//                           {empDetails.designation}
//                         </td>
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           {new Date(l.startDate).toLocaleDateString()} <br />
//                           <span className="text-xs text-gray-500">to</span> <br />
//                           {new Date(l.endDate).toLocaleDateString()}
//                         </td>
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           <span className="px-2 py-2 text-xs text-center text-blue-700 bg-blue-100 rounded-full">
//                             {l.days} {l.days === 1 ? 'day' : 'days'}
//                           </span>
//                         </td>
//                         <td className="max-w-xs px-2 py-2 font-medium text-center text-gray-500 truncate whitespace-nowrap">
//                           {l.reason}
//                         </td>
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           {l.status === "approved" && (
//                             <span className="px-2 py-2 text-xs text-center text-green-700 bg-blue-100 rounded-full">
//                               ✅ Approved
//                             </span>
//                           )}
//                           {l.status === "pending" && (
//                             <span className="px-2 py-2 text-xs text-center text-yellow-700 bg-yellow-100 rounded-full">
//                               ⏳ Pending
//                             </span>
//                           )}
//                           {l.status === "rejected" && (
//                             <span className="px-2 py-2 text-xs text-center text-red-700 bg-red-100 rounded-full">
//                               ❌ Rejected
//                             </span>
//                           )}
//                         </td>
//                         <td className="px-2 py-2 font-medium text-center text-gray-900 whitespace-nowrap">
//                           {l.status === "pending" ? (
//                             <div className="flex justify-center gap-2">
//                               <button
//                                 onClick={() => updateLeaveStatus(l._id, "approved")}
//                                 className="px-2 py-2 text-xs text-center text-gray-900 transition bg-blue-600 rounded-md hover:bg-blue-600"
//                               >
//                                 Approve
//                               </button>
//                               <button
//                                 onClick={() => updateLeaveStatus(l._id, "rejected")}
//                                 className="px-2 py-2 text-xs text-center text-gray-900 transition bg-red-500 rounded-md hover:bg-red-600"
//                               >
//                                 Reject
//                               </button>
//                             </div>
//                           ) : (
//                             <span className="text-xs italic text-gray-500">
//                               No actions
//                             </span>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="9" className="py-6 text-center text-gray-500">
//                       No leave records found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ✅ Pagination Section */}
//         {filteredLeaves.length > 0 && (
//           <div className="flex flex-col items-center justify-between gap-4 mt-6 sm:flex-row">
//             <div className="flex flex-wrap items-center gap-4">
//               <div className="flex items-center gap-2">
//                 <label className="font-medium text-gray-700 ">
//                   Show:
//                 </label>
//                 <select
//                   value={itemsPerPage}
//                   onChange={handleItemsPerPageChange}
//                   className="p-2 border rounded-lg"
//                 >
//                   <option value={5}>5</option>
//                   <option value={10}>10</option>
//                   <option value={20}>20</option>
//                   <option value={50}>50</option>
//                 </select>
//                 <span className="text-sm text-gray-500">entries</span>
//               </div>
//             </div>

//             <div className="flex items-center gap-2">
//               <button
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 1}
//                 className={`px-4 py-1 text-sm border rounded-lg ${currentPage === 1
//                     ? "text-gray-500 bg-gray-100 cursor-not-allowed"
//                     : "text-blue-600 bg-white hover:bg-blue-50 border-blue-200"
//                   }`}
//               >
//                 Previous
//               </button>

//               {getPageNumbers().map((page, index) => (
//                 <button
//                   key={index}
//                   onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                   disabled={page === "..."}
//                   className={`px-4 py-1 text-sm border rounded-lg ${page === "..."
//                       ? "text-gray-500 bg-white cursor-default"
//                       : currentPage === page
//                         ? "text-gray-900 bg-blue-600 border-blue-600"
//                         : "text-blue-600 bg-white hover:bg-blue-50 border-blue-300"
//                     }`}
//                 >
//                   {page}
//                 </button>
//               ))}

//               <button
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//                 className={`px-4 py-1 text-sm border rounded-lg ${currentPage === totalPages
//                     ? "text-gray-500 bg-gray-100 cursor-not-allowed"
//                     : "text-blue-600 bg-white hover:bg-blue-50 border-blue-300"
//                   }`}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LeavesList;


import axios from "axios";
import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { FaBuilding, FaExchangeAlt, FaSearch, FaUserTag, FaChevronUp, FaChevronDown, FaEye } from "react-icons/fa";
import { FiCalendar, FiCheckCircle, FiClock, FiDownload, FiFilter, FiList, FiSearch, FiTrash2, FiX, FiXCircle } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { isEmployeeHidden } from "../utils/employeeStatus";
import "./EmployeeList.css";
import "./EmployeeDashboard.css";

const LeavesList = () => {
  const [leaves, setLeaves] = useState([]);
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const [employees, setEmployees] = useState([]);

  // Comp-off requests state
  const [compOffRequests, setCompOffRequests] = useState([]);
  const [showCompOffRequests, setShowCompOffRequests] = useState(false);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [compOffTab, setCompOffTab] = useState("pending");

  // Approved comp-offs state
  const [approvedCompOffs, setApprovedCompOffs] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const saved = localStorage.getItem('leavesList_itemsPerPage');
    return saved ? parseInt(saved, 10) : 10;
  });

  // Filters
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [leaveTypeFilter, setLeaveTypeFilter] = useState("all");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const [filterDepartment, setFilterDepartment] = useState("");
  const [filterDesignation, setFilterDesignation] = useState("");
  const [showDepartmentFilter, setShowDepartmentFilter] = useState(false);
  const [showDesignationFilter, setShowDesignationFilter] = useState(false);

  // Comp-off review popups
  const [showCompOffPopup, setShowCompOffPopup] = useState(false);
  const [selectedCompOffRequest, setSelectedCompOffRequest] = useState(null);

  const [showEditCompOffPopup, setShowEditCompOffPopup] = useState(false);
  const [selectedCompOffForEdit, setSelectedCompOffForEdit] = useState(null);
  const [editCompOffData, setEditCompOffData] = useState({ count: 1, reason: "" });

  // View comp-off modal (read-only)
  const [showViewCompOffModal, setShowViewCompOffModal] = useState(false);
  const [viewCompOffData, setViewCompOffData] = useState(null);

  const [uniqueDepartments, setUniqueDepartments] = useState([]);
  const [uniqueDesignations, setUniqueDesignations] = useState([]);

  const departmentFilterRef = useRef(null);
  const designationFilterRef = useRef(null);
  const compOffPopupRef = useRef(null);
  const editCompOffPopupRef = useRef(null);
  const balancePopupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (departmentFilterRef.current && !departmentFilterRef.current.contains(event.target)) setShowDepartmentFilter(false);
      if (designationFilterRef.current && !designationFilterRef.current.contains(event.target)) setShowDesignationFilter(false);
      if (compOffPopupRef.current && !compOffPopupRef.current.contains(event.target)) setShowCompOffPopup(false);
      if (editCompOffPopupRef.current && !editCompOffPopupRef.current.contains(event.target)) setShowEditCompOffPopup(false);
      if (balancePopupRef.current && !balancePopupRef.current.contains(event.target)) setShowBalancePopup(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchLeaves = async () => {
    try {
      setLoading(true);
      const [leavesRes, empRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/leaves/leaves`),
        axios.get(`${API_BASE_URL}/employees/get-employees`)
      ]);

      const employeesData = empRes.data || [];
      const activeEmployees = employeesData.filter(emp => !isEmployeeHidden(emp));
      setEmployees(activeEmployees);

      const depts = new Set();
      const designations = new Set();
      activeEmployees.forEach(emp => {
        if (emp.department) depts.add(emp.department);
        if (emp.role || emp.designation) designations.add(emp.role || emp.designation);
      });
      setUniqueDepartments(Array.from(depts).sort());
      setUniqueDesignations(Array.from(designations).sort());

      const leavesData = leavesRes.data.records || leavesRes.data || [];

      // Fetch approved comp-offs
      let compOffMap = new Map();
      try {
        const compOffsRes = await axios.get(`${API_BASE_URL}/leaves/comp-offs`);
        const compOffs = compOffsRes.data || [];
        setApprovedCompOffs(compOffs);
        compOffs.forEach(co => {
          if (co.originalLeaveId) {
            compOffMap.set(co.originalLeaveId.toString(), {
              id: co._id,
              status: co.status,
              count: co.count || 1,
              reason: co.reason,
              workDate: co.workDate,
              full: co
            });
          }
        });
      } catch (error) {
        console.log("Comp-offs not available yet");
      }

      // Fetch rejected comp-offs
      try {
        const rejectedCompOffsRes = await axios.get(`${API_BASE_URL}/leaves/comp-offs?status=rejected`);
        const rejectedCompOffs = rejectedCompOffsRes.data || [];
        rejectedCompOffs.forEach(co => {
          if (co.originalLeaveId && !compOffMap.has(co.originalLeaveId.toString())) {
            compOffMap.set(co.originalLeaveId.toString(), {
              id: co._id,
              status: co.status,
              count: co.count || 1,
              reason: co.reason,
              workDate: co.workDate,
              full: co
            });
          }
        });
      } catch (error) {
        console.log("No rejected comp-offs");
      }

      const leavesWithStatus = leavesData.map(leave => ({
        ...leave,
        compOffStatus: compOffMap.get(leave._id?.toString()) || null
      }));

      const sorted = leavesWithStatus.sort((a, b) => new Date(b.createdAt || b.startDate) - new Date(a.createdAt || a.startDate));
      const activeEmployeeIds = new Set(activeEmployees.map(emp => emp.employeeId || emp._id));
      let filteredLeavesData = sorted.filter(leave => activeEmployeeIds.has(leave.employeeId));

      const userRoleStr = localStorage.getItem("userRole");
      if (userRoleStr === "employee") {
        const empData = JSON.parse(localStorage.getItem("employeeData") || "{}");
        const empRole = (empData.role || empData.designation || "").toLowerCase();
        const empDept = (empData.department || empData.departmentName || "").toLowerCase();
        const isHRManagement = empRole.includes("hr") || empDept.includes("hr") || empRole.includes("management") || empDept.includes("management") || empDept.includes("human resources");

        if (!isHRManagement) {
          filteredLeavesData = filteredLeavesData.filter(leave => {
            const leaveEmp = activeEmployees.find(e => e.employeeId === leave.employeeId || e._id === leave.employeeId);
            const leaveDept = (leaveEmp?.department || leaveEmp?.departmentName || leave.department || "").toLowerCase();
            return leaveDept === empDept;
          });
        }
      }

      setLeaves(filteredLeavesData);
      setFilteredLeaves(filteredLeavesData);
      setCurrentPage(1);
    } catch (err) {
      console.error("Failed to fetch leaves:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompOffRequests = async () => {
    setLoadingRequests(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/leaves/comp-off-requests?status=all`);
      const data = response.data || [];
      setCompOffRequests(Array.isArray(data) ? data : (data.requests || []));
    } catch (error) {
      console.error("Error fetching comp-off requests:", error);
    } finally {
      setLoadingRequests(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
    fetchCompOffRequests();
  }, []);

  const getEmployeeDetails = (employeeId) => {
    const emp = employees.find(e => e.employeeId === employeeId || e._id === employeeId);
    return {
      department: emp?.department || emp?.departmentName || "N/A",
      designation: emp?.designation || emp?.role || "N/A"
    };
  };

  const updateLeaveStatus = async (id, status) => {
    try {
      const userRoleStr = localStorage.getItem("userRole");
      let approverName = "Admin";
      let approverRole = "Admin";
      let approverEmail = "";

      if (userRoleStr === "employee") {
        const empData = JSON.parse(localStorage.getItem("employeeData") || "{}");
        approverName = localStorage.getItem("employeeName") || empData.name;
        approverRole = empData.designation || empData.role || "Manager";
        approverEmail = localStorage.getItem("employeeEmail") || empData.email || "";
      } else {
        approverName = localStorage.getItem("adminName") || "Admin";
        approverRole = "Admin";
        approverEmail = localStorage.getItem("adminEmail") || "";
      }

      const res = await axios.put(`${API_BASE_URL}/leaves/updateleaves/${id}`, {
        status,
        adminName: approverName,
        adminEmail: approverEmail,
        adminRole: approverRole
      });
      if (res.status === 200) {
        alert(`Leave ${status} successfully`);
        fetchLeaves();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update leave status");
    }
  };

  const approveCompOffRequest = async () => {
    if (!selectedCompOffRequest) return;
    const existingCompOff = approvedCompOffs.find(co => co.employeeId === selectedCompOffRequest.employeeId && co.workDate === selectedCompOffRequest.workDate && co.status === "approved");

    if (existingCompOff) {
      const userConfirmed = window.confirm(`⚠️ This employee already has an approved comp-off for ${new Date(selectedCompOffRequest.workDate).toLocaleDateString()}. \nCurrent count: ${existingCompOff.count || 1} days\nNew request: ${selectedCompOffRequest.count || 1} days\n\nDo you want to add to existing comp-off?`);
      if (userConfirmed) {
        try {
          const updatedCount = (existingCompOff.count || 1) + (selectedCompOffRequest.count || 1);
          await axios.put(`${API_BASE_URL}/leaves/comp-offs/update/${existingCompOff._id}`, {
            count: updatedCount,
            reason: existingCompOff.reason + `\n+ Added ${selectedCompOffRequest.count} day(s) on ${new Date().toLocaleDateString()}`,
            updatedBy: localStorage.getItem("adminName") || "Admin"
          });
          await axios.delete(`${API_BASE_URL}/leaves/comp-off-requests/${selectedCompOffRequest._id}`);
          alert(`✅ Comp-off count updated to ${updatedCount} days!`);
          setShowCompOffPopup(false);
          setSelectedCompOffRequest(null);
          fetchCompOffRequests();
          fetchLeaves();
        } catch (error) {
          alert("Failed to update comp-off");
        }
        return;
      } else {
        setShowCompOffPopup(false);
        setSelectedCompOffRequest(null);
        return;
      }
    }

    try {
      await axios.put(`${API_BASE_URL}/leaves/comp-off-requests/${selectedCompOffRequest._id}/approve`, {
        approvedBy: localStorage.getItem("adminName") || "Admin"
      });
      alert("✅ Comp-off request approved!");
      setShowCompOffPopup(false);
      setSelectedCompOffRequest(null);
      fetchCompOffRequests();
      fetchLeaves();
    } catch (error) {
      alert(error.response?.data?.error || "Failed to approve request");
    }
  };

  const rejectCompOffRequest = async () => {
    if (!selectedCompOffRequest) return;
    const reason = prompt("Enter rejection reason (optional):");
    try {
      await axios.put(`${API_BASE_URL}/leaves/comp-off-requests/${selectedCompOffRequest._id}/reject`, {
        approvedBy: localStorage.getItem("adminName") || "Admin",
        rejectionReason: reason
      });
      alert("❌ Comp-off request rejected!");
      setShowCompOffPopup(false);
      setSelectedCompOffRequest(null);
      fetchCompOffRequests();
      fetchLeaves();
    } catch (error) {
      alert(error.response?.data?.error || "Failed to reject request");
    }
  };

  const editApprovedCompOff = (compOff) => {
    setSelectedCompOffForEdit(compOff);
    setEditCompOffData({ count: compOff.count || 1, reason: compOff.reason || "" });
    setShowEditCompOffPopup(true);
  };

  const saveEditedCompOff = async () => {
    if (!selectedCompOffForEdit) return;
    try {
      await axios.put(`${API_BASE_URL}/leaves/comp-offs/update/${selectedCompOffForEdit._id}`, {
        count: editCompOffData.count,
        reason: editCompOffData.reason,
        updatedBy: localStorage.getItem("adminName") || "Admin"
      });
      alert("✅ Comp-off updated successfully!");
      setShowEditCompOffPopup(false);
      setSelectedCompOffForEdit(null);
      fetchLeaves();
    } catch (error) {
      alert("Failed to update comp-off");
    }
  };

  const rejectApprovedCompOff = async () => {
    if (!selectedCompOffForEdit) return;
    const reason = prompt("Enter rejection reason (optional):");
    try {
      await axios.put(`${API_BASE_URL}/leaves/comp-offs/${selectedCompOffForEdit._id}`, {
        status: "rejected",
        approvedBy: localStorage.getItem("adminName") || "Admin"
      });
      alert("❌ Comp-off rejected successfully!");
      setShowEditCompOffPopup(false);
      setSelectedCompOffForEdit(null);
      fetchLeaves();
    } catch (error) {
      alert("Failed to reject comp-off");
    }
  };

  const deleteApprovedCompOff = async (compOffId) => {
    if (!window.confirm("Are you sure you want to delete this comp-off? This action cannot be undone.")) return;
    try {
      await axios.delete(`${API_BASE_URL}/leaves/comp-offs/${compOffId}`);
      alert("✅ Comp-off deleted successfully!");
      fetchLeaves();
    } catch (error) {
      alert("Failed to delete comp-off");
    }
  };

  // ✅ Read-only view
  const openViewCompOffModal = (data) => {
    setViewCompOffData(data);
    setShowViewCompOffModal(true);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const [showBalancePopup, setShowBalancePopup] = useState(false);
  const [selectedEmpBalance, setSelectedEmpBalance] = useState(null);

  const viewEmployeeBalances = async (employeeId, employeeName) => {
    try {
      const resp = await axios.get(`${API_BASE_URL}/leaves/balances/${employeeId}`);
      if (resp.data?.success) {
        setSelectedEmpBalance({ employeeId, employeeName, balances: resp.data.balances });
        setShowBalancePopup(true);
      }
    } catch (err) {
      alert("Failed to fetch balances");
    }
  };

  // Filters
  useEffect(() => {
    let filtered = [...leaves];
    const userRoleStr = localStorage.getItem("userRole");
    if (userRoleStr === "employee") {
      const empData = JSON.parse(localStorage.getItem("employeeData") || "{}");
      const empRole = (empData.role || empData.designation || "").toLowerCase();
      const perms = JSON.parse(localStorage.getItem("employeePermissions") || "[]");
      const hasLeaveApprove = perms.includes("leave_approve");
      const isHR = empRole.includes("hr");
      const isDepartmentHead = (!isHR) && (empRole.includes("manager") || empRole.includes("lead") || empRole.includes("head") || hasLeaveApprove);

      if (!isHR) {
        if (isDepartmentHead) {
          const empDept = (empData.department || empData.departmentName || "").toLowerCase();
          filtered = filtered.filter(l => (getEmployeeDetails(l.employeeId).department || "").toLowerCase() === empDept);
        } else {
          filtered = filtered.filter(l => l.employeeId === (empData.employeeId || empData._id));
        }
      }
    }

    if (searchTerm) filtered = filtered.filter(l => l.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) || l.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) || l.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) || l.reason?.toLowerCase().includes(searchTerm.toLowerCase()));
    if (statusFilter !== "all") filtered = filtered.filter(l => l.status === statusFilter);
    if (leaveTypeFilter !== "all") filtered = filtered.filter(l => l.leaveType === leaveTypeFilter);
    if (startDateFilter) filtered = filtered.filter(l => new Date(l.startDate) >= new Date(startDateFilter));
    if (endDateFilter) filtered = filtered.filter(l => new Date(l.endDate) <= new Date(endDateFilter));
    if (filterDepartment) filtered = filtered.filter(l => getEmployeeDetails(l.employeeId).department === filterDepartment);
    if (filterDesignation) filtered = filtered.filter(l => getEmployeeDetails(l.employeeId).designation === filterDesignation);

    if (selectedMonth) {
      const [year, monthNum] = selectedMonth.split("-").map(Number);
      filtered = filtered.filter(l => {
        const d = new Date(l.startDate);
        return d.getFullYear() === year && d.getMonth() + 1 === monthNum;
      });
    }

    setFilteredLeaves(filtered);
    setCurrentPage(1);
  }, [searchTerm, statusFilter, leaveTypeFilter, startDateFilter, endDateFilter, filterDepartment, filterDesignation, selectedMonth, leaves]);

  const clearFilters = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setLeaveTypeFilter("all");
    setStartDateFilter("");
    setEndDateFilter("");
    setFilterDepartment("");
    setFilterDesignation("");
    setSelectedMonth("");
  };

  const navigate = useNavigate();
  const location = useLocation();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLeaves.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

  const handleItemsPerPageChange = (e) => {
    const newValue = Number(e.target.value);
    setItemsPerPage(newValue);
    localStorage.setItem('leavesList_itemsPerPage', String(newValue));
    setCurrentPage(1);
  };

  const handlePrevPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
  const handleNextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
  const handlePageClick = (page) => setCurrentPage(page);

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) pageNumbers.push(i);
      else if (i === currentPage - 3 || i === currentPage + 3) pageNumbers.push("...");
    }
    return pageNumbers;
  };

  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-3 border-3 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
        <p className="text-sm font-medium text-gray-600">Loading leave requests...</p>
      </div>
    </div>
  );

  return (
    <div className="emp-dash">
      <main className="p-1 sm:p-2 lg:p-6">

        {/* Desktop Header */}
        <div className="hidden lg:flex items-center justify-between gap-3 flex-wrap mb-4">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="emp-dash__greeting text-lg sm:text-xl font-bold whitespace-nowrap leading-none">
              Leave <span>Requests</span>
            </h1>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <div className="relative min-w-[130px]">
              <FiSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-[10px]" />
              <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} className="w-[130px] pl-7 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 bg-white" />
            </div>

            {/* Department Filter */}
            <div className="relative" ref={departmentFilterRef}>
              <button onClick={() => { setShowDepartmentFilter(!showDepartmentFilter); setShowDesignationFilter(false); }} className={`flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${filterDepartment ? 'border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}>
                <FaBuilding className="text-gray-400 text-[10px]" />
                <span className="truncate max-w-[80px]">{filterDepartment || 'Dept'}</span>
                <span className="text-gray-400 text-[10px]">▾</span>
              </button>
              {showDepartmentFilter && (
                <div className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[180px] max-h-60 overflow-y-auto" style={{ zIndex: 99999, top: departmentFilterRef.current ? departmentFilterRef.current.getBoundingClientRect().bottom + 4 : 'auto', left: departmentFilterRef.current ? departmentFilterRef.current.getBoundingClientRect().left : 'auto' }}>
                  <div onClick={() => { setFilterDepartment(''); setShowDepartmentFilter(false); setCurrentPage(1); }} className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50">All Departments</div>
                  {uniqueDepartments.map(dept => (<div key={dept} onClick={() => { setFilterDepartment(dept); setShowDepartmentFilter(false); setCurrentPage(1); }} className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${filterDepartment === dept ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-gray-700'}`}>{dept}</div>))}
                </div>
              )}
            </div>

            {/* Designation Filter */}
            <div className="relative" ref={designationFilterRef}>
              <button onClick={() => { setShowDesignationFilter(!showDesignationFilter); setShowDepartmentFilter(false); }} className={`flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium rounded-lg border transition-all bg-white whitespace-nowrap ${filterDesignation ? 'border-blue-500 text-blue-700 ring-2 ring-blue-500/10 bg-blue-50' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}>
                <FaUserTag className="text-gray-400 text-[10px]" />
                <span className="truncate max-w-[80px]">{filterDesignation || 'Design'}</span>
                <span className="text-gray-400 text-[10px]">▾</span>
              </button>
              {showDesignationFilter && (
                <div className="fixed bg-white border border-gray-200 rounded-lg shadow-2xl min-w-[180px] max-h-60 overflow-y-auto" style={{ zIndex: 99999, top: designationFilterRef.current ? designationFilterRef.current.getBoundingClientRect().bottom + 4 : 'auto', left: designationFilterRef.current ? designationFilterRef.current.getBoundingClientRect().left : 'auto' }}>
                  <div onClick={() => { setFilterDesignation(''); setShowDesignationFilter(false); setCurrentPage(1); }} className="px-3 py-2 text-xs font-medium text-gray-500 border-b border-gray-100 cursor-pointer hover:bg-blue-50">All Designations</div>
                  {uniqueDesignations.map(des => (<div key={des} onClick={() => { setFilterDesignation(des); setShowDesignationFilter(false); setCurrentPage(1); }} className={`px-3 py-2 text-xs cursor-pointer hover:bg-blue-50 ${filterDesignation === des ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-gray-700'}`}>{des}</div>))}
                </div>
              )}
            </div>

            {/* Status Filter Tabs */}
            <div className="flex items-center bg-gray-100 p-0.5 rounded-lg h-8">
              <button onClick={() => { setStatusFilter('all'); setCurrentPage(1); }} className={`px-2.5 py-1 text-[10px] font-semibold rounded-md transition-all whitespace-nowrap ${statusFilter === 'all' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>All</button>
              <button onClick={() => { setStatusFilter('pending'); setCurrentPage(1); }} className={`px-2.5 py-1 text-[10px] font-semibold rounded-md transition-all whitespace-nowrap ${statusFilter === 'pending' ? 'bg-white text-amber-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>Pending ({leaves.filter(l => l.status === 'pending').length})</button>
              <button onClick={() => { setStatusFilter('approved'); setCurrentPage(1); }} className={`px-2.5 py-1 text-[10px] font-semibold rounded-md transition-all whitespace-nowrap ${statusFilter === 'approved' ? 'bg-white text-green-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>Approved</button>
              <button onClick={() => { setStatusFilter('rejected'); setCurrentPage(1); }} className={`px-2.5 py-1 text-[10px] font-semibold rounded-md transition-all whitespace-nowrap ${statusFilter === 'rejected' ? 'bg-white text-red-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>Rejected</button>
            </div>

            {/* Comp-off Button */}
            <button onClick={() => setShowCompOffRequests(!showCompOffRequests)} className={`flex items-center gap-1 px-2.5 py-1.5 text-xs font-semibold rounded-lg hover:opacity-90 transition-all shadow-sm whitespace-nowrap ${showCompOffRequests ? 'text-white bg-purple-600' : 'text-purple-700 bg-purple-50 border border-purple-200'}`}>
              <FaExchangeAlt className="w-3 h-3" />
              Comp-off {compOffRequests.filter(r => r.status === 'pending').length > 0 && <span className="ml-0.5 bg-red-500 text-white rounded-full min-w-[16px] h-4 px-1 text-[9px] font-bold flex items-center justify-center">{compOffRequests.filter(r => r.status === 'pending').length}</span>}
            </button>

            {/* Export */}
            <button onClick={() => { if (filteredLeaves.length === 0) { alert("No data to download!"); return; } const headers = ["Emp ID","Name","Department","Designation","Leave Type","Start Date","End Date","Days","Reason","Status","Approved By","Comp-off"]; const csvRows = [headers.join(","), ...filteredLeaves.map(l => { const ed = getEmployeeDetails(l.employeeId); const co = l.compOffStatus?.status || '-'; return [`"${l.employeeId||''}"`,"\""+l.employeeName+"\"","\""+ed.department+"\"","\""+ed.designation+"\"","\""+l.leaveType+"\"",new Date(l.startDate).toLocaleDateString(),new Date(l.endDate).toLocaleDateString(),l.days||1,"\""+( l.reason||'').replace(/"/g,"'")+"\"",l.status,"\""+( l.approvedBy||'-')+"\"","\""+co+"\""].join(","); })]; const blob = new Blob([csvRows.join("\n")], { type: "text/csv" }); const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = `leave_requests_${new Date().toISOString().slice(0,10)}.csv`; a.click(); URL.revokeObjectURL(url); }} className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition-all shadow-sm whitespace-nowrap">
              <FiDownload className="w-3 h-3" /> Export
            </button>

            {(filterDepartment || filterDesignation || searchTerm || statusFilter !== 'all' || leaveTypeFilter !== 'all' || selectedMonth || startDateFilter || endDateFilter) && (
              <button onClick={clearFilters} className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all shadow-sm whitespace-nowrap">
                <FiTrash2 className="w-3 h-3" /> Clear
              </button>
            )}
          </div>
        </div>

        {/* Mobile Header */}
        <div className="lg:hidden flex items-center justify-between gap-2 flex-wrap mb-3">
          <h1 className="text-base font-bold whitespace-nowrap">Leave <span className="text-blue-600">Requests</span></h1>
        </div>

        {/* Mobile Filters */}
        <div className="lg:hidden mb-3">
          <div className="flex items-center justify-between p-2.5 bg-white rounded-xl border border-gray-200">
            <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="flex items-center gap-2 text-sm font-semibold text-gray-700">
              <FiFilter className="text-blue-600 text-base" />
              <span>Filters</span>
              {showMobileFilters ? <FaChevronUp className="text-gray-400" /> : <FaChevronDown className="text-gray-400" />}
            </button>
            <span className="text-xs text-gray-500"><strong>{filteredLeaves.length}</strong> requests</span>
          </div>

          {showMobileFilters && (
            <div className="mt-2 p-4 bg-white rounded-xl border border-gray-200 space-y-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Search</label>
                <div className="relative">
                  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
                <div className="flex bg-gray-100 p-1 rounded-lg">
                  {['all','pending','approved','rejected'].map(s => (
                    <button key={s} onClick={() => { setStatusFilter(s); setCurrentPage(1); }} className={`flex-1 py-1.5 text-xs font-semibold rounded-md transition-all capitalize ${statusFilter === s ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600'}`}>{s}</button>
                  ))}
                </div>
              </div>

              <div className="pt-3 border-t border-gray-200 grid grid-cols-2 gap-2">
                <button onClick={() => setShowCompOffRequests(!showCompOffRequests)} className={`flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-semibold rounded-lg ${showCompOffRequests ? 'text-white bg-purple-600' : 'text-purple-700 bg-purple-50 border border-purple-200'}`}>
                  <FaExchangeAlt className="w-4 h-4" /> Comp-off
                  {compOffRequests.filter(r => r.status === 'pending').length > 0 && <span className="ml-1 bg-red-500 text-white rounded-full min-w-[18px] h-4 px-1 text-[10px] font-bold flex items-center justify-center">{compOffRequests.filter(r => r.status === 'pending').length}</span>}
                </button>
                <button onClick={() => { if (filteredLeaves.length === 0) { alert("No data to download!"); return; } const headers = ["Emp ID","Name","Department","Designation","Leave Type","Start Date","End Date","Days","Reason","Status","Approved By","Comp-off"]; const csvRows = [headers.join(","), ...filteredLeaves.map(l => { const ed = getEmployeeDetails(l.employeeId); const co = l.compOffStatus?.status || '-'; return [`"${l.employeeId||''}"`,"\""+l.employeeName+"\"","\""+ed.department+"\"","\""+ed.designation+"\"","\""+l.leaveType+"\"",new Date(l.startDate).toLocaleDateString(),new Date(l.endDate).toLocaleDateString(),l.days||1,"\""+( l.reason||'').replace(/"/g,"'")+"\"",l.status,"\""+( l.approvedBy||'-')+"\"","\""+co+"\""].join(","); })]; const blob = new Blob([csvRows.join("\n")], { type: "text/csv" }); const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = `leave_requests_${new Date().toISOString().slice(0,10)}.csv`; a.click(); URL.revokeObjectURL(url); }} className="flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-semibold text-white bg-green-600 rounded-lg">
                  <FiDownload className="w-4 h-4" /> Export
                </button>
                {(filterDepartment || filterDesignation || searchTerm || statusFilter !== 'all' || selectedMonth) && (
                  <button onClick={clearFilters} className="col-span-2 flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg">
                    <FiTrash2 className="w-4 h-4" /> Clear All
                  </button>
                )}
              </div>
            </div>
          )}
        </div>

        {/* KPI Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6">
          <div className="emp-dash__stat cursor-pointer transition-all hover:shadow-md" onClick={() => navigate("/leavelist")}>
            <div className="emp-dash__stat-top"><span className="emp-dash__stat-label text-[10px] sm:text-xs">Total Requests</span><div className="emp-dash__stat-icon emp-dash__stat-icon--rate"><FiList className="text-sm sm:text-base" /></div></div>
            <div className="emp-dash__stat-value text-xl sm:text-2xl">{leaves.length}</div>
            <div className="emp-dash__stat-meta text-[10px] sm:text-xs">all requests</div>
          </div>

          <div className="emp-dash__stat cursor-pointer transition-all hover:shadow-md" onClick={() => navigate(location.pathname.startsWith("/emp-") ? "/emp-pending-leaves" : "/pending-leaves")}>
            <div className="emp-dash__stat-top"><span className="emp-dash__stat-label text-[10px] sm:text-xs">Pending</span><div className="emp-dash__stat-icon emp-dash__stat-icon--absent"><FiClock className="text-sm sm:text-base" /></div></div>
            <div className="emp-dash__stat-value text-xl sm:text-2xl text-amber-600">{leaves.filter((l) => l.status === "pending").length}</div>
            <div className="emp-dash__stat-meta text-[10px] sm:text-xs">awaiting approval</div>
          </div>

          <div className="emp-dash__stat cursor-pointer transition-all hover:shadow-md" onClick={() => navigate(location.pathname.startsWith("/emp-") ? "/emp-approved-leaves" : "/approved-leaves")}>
            <div className="emp-dash__stat-top"><span className="emp-dash__stat-label text-[10px] sm:text-xs">Approved</span><div className="emp-dash__stat-icon emp-dash__stat-icon--present"><FiCheckCircle className="text-sm sm:text-base" /></div></div>
            <div className="emp-dash__stat-value text-xl sm:text-2xl text-green-600">{leaves.filter((l) => l.status === "approved").length}</div>
            <div className="emp-dash__stat-meta text-[10px] sm:text-xs">approved</div>
          </div>

          <div className="emp-dash__stat col-span-2 lg:col-span-1 cursor-pointer transition-all hover:shadow-md" onClick={() => navigate(location.pathname.startsWith("/emp-") ? "/emp-rejected-leaves" : "/rejected-leaves")}>
            <div className="emp-dash__stat-top"><span className="emp-dash__stat-label text-[10px] sm:text-xs">Rejected</span><div className="emp-dash__stat-icon emp-dash__stat-icon--absent"><FiXCircle className="text-sm sm:text-base" /></div></div>
            <div className="emp-dash__stat-value text-xl sm:text-2xl text-red-600">{leaves.filter((l) => l.status === "rejected").length}</div>
            <div className="emp-dash__stat-meta text-[10px] sm:text-xs">rejected</div>
          </div>
        </div>

        {/* Active Filter Info */}
        {(filterDepartment || filterDesignation || searchTerm || statusFilter !== 'all' || selectedMonth || startDateFilter || endDateFilter) && (
          <div className="mb-3 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
            <span className="text-xs font-medium text-blue-700">🔍 Filters active — showing <strong>{filteredLeaves.length}</strong> of <strong>{leaves.length}</strong> requests</span>
            <button onClick={clearFilters} className="text-xs text-blue-600 hover:text-blue-800 font-semibold flex items-center gap-1"><FiX className="w-3 h-3" /> Clear</button>
          </div>
        )}

        {/* Comp-off Requests Section */}
        {showCompOffRequests && (
          <div className="mb-6 overflow-hidden bg-white border-2 border-purple-200 rounded-lg shadow-lg">
            <div className="flex items-center justify-between px-4 py-2 text-white bg-gradient-to-r from-purple-500 to-purple-700">
              <h3 className="flex items-center gap-2 font-semibold"><FaExchangeAlt /> Comp-off Requests ({compOffRequests.length})</h3>
              <button onClick={fetchCompOffRequests} className="px-2 py-1 text-xs text-purple-700 bg-white rounded hover:bg-purple-100 font-semibold">🔄 Refresh</button>
            </div>

            {/* Status Tabs */}
            <div className="flex items-center gap-2 px-4 py-2.5 bg-purple-50 border-b border-purple-100">
              <button
                onClick={() => setCompOffTab("pending")}
                className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${
                  compOffTab === "pending" ? "bg-amber-500 text-white shadow-sm" : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                }`}
              >
                Pending ({compOffRequests.filter(r => r.status === "pending").length})
              </button>
              <button
                onClick={() => setCompOffTab("approved")}
                className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${
                  compOffTab === "approved" ? "bg-green-600 text-white shadow-sm" : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                }`}
              >
                Approved ({compOffRequests.filter(r => r.status === "approved").length})
              </button>
              <button
                onClick={() => setCompOffTab("rejected")}
                className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${
                  compOffTab === "rejected" ? "bg-red-600 text-white shadow-sm" : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                }`}
              >
                Rejected ({compOffRequests.filter(r => r.status === "rejected").length})
              </button>
              <button
                onClick={() => setCompOffTab("all")}
                className={`px-3 py-1 text-xs font-semibold rounded-md transition-all ${
                  compOffTab === "all" ? "bg-purple-700 text-white shadow-sm" : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                }`}
              >
                All ({compOffRequests.length})
              </button>
            </div>

            {loadingRequests ? (
              <div className="p-8 text-center"><div className="w-8 h-8 mx-auto border-b-2 border-purple-600 rounded-full animate-spin"></div><p className="mt-2 text-sm text-gray-500">Loading requests...</p></div>
            ) : compOffRequests.filter(r => compOffTab === "all" ? true : r.status === compOffTab).length === 0 ? (
              <div className="p-8 text-center text-gray-500 font-medium">No {compOffTab === "all" ? "" : compOffTab} comp-off requests found</div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead className="text-xs text-purple-800 bg-purple-100">
                    <tr>
                      <th className="px-3 py-2 text-center">Employee</th>
                      <th className="px-3 py-2 text-center">Work Date (Extra Day)</th>
                      <th className="px-3 py-2 text-center">Days</th>
                      <th className="px-3 py-2 text-center">Reason</th>
                      <th className="px-3 py-2 text-center">Status</th>
                      <th className="px-3 py-2 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {compOffRequests.filter(r => compOffTab === "all" ? true : r.status === compOffTab).map(req => (
                      <tr key={req._id} className="border-b hover:bg-purple-50">
                        <td className="px-3 py-2 text-center"><div className="font-semibold text-gray-900">{req.employeeName}</div><div className="text-xs text-gray-500">{req.employeeId}</div></td>
                        <td className="px-3 py-2 text-center">
                          <div className="font-medium text-gray-800">{formatDate(req.workDate)}</div>
                          {req.extraDayDetails?.workType && <span className="inline-block text-[10px] text-purple-600 bg-purple-50 px-1.5 py-0.5 rounded">{req.extraDayDetails.workType}</span>}
                        </td>
                        <td className="px-3 py-2 text-center"><span className="px-2 py-1 text-xs font-semibold text-purple-700 bg-purple-100 rounded-full">{req.count || 1} day(s)</span></td>
                        <td className="max-w-xs px-3 py-2 text-center"><span className="block text-xs text-gray-700 truncate" title={req.reason}>{req.reason || 'No reason provided'}</span></td>
                        <td className="px-3 py-2 text-center">
                          {req.status === "approved" && <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700 border border-green-200">✅ Approved</span>}
                          {req.status === "rejected" && <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-red-100 text-red-700 border border-red-200">❌ Rejected</span>}
                          {req.status === "pending" && <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-amber-100 text-amber-700 border border-amber-200">⏳ Pending</span>}
                        </td>
                        <td className="px-3 py-2 text-center">
                          {req.status === "pending" ? (
                            <button onClick={() => { setSelectedCompOffRequest(req); setShowCompOffPopup(true); }} className="px-3 py-1 text-xs font-semibold text-white bg-purple-600 rounded-md hover:bg-purple-700 shadow-sm">Review</button>
                          ) : req.status === "approved" ? (
                            <span className="text-xs text-gray-500">Approved by {req.approvedBy || "Admin"}</span>
                          ) : (
                            <span className="text-xs text-red-500 truncate max-w-[120px] block" title={req.rejectionReason}>{req.rejectionReason ? `Reason: ${req.rejectionReason}` : "Rejected"}</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Comp-off Review Popup (approve/reject) */}
        {showCompOffPopup && selectedCompOffRequest && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div ref={compOffPopupRef} className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl">
              <h2 className="mb-4 text-xl font-bold text-purple-800">Review Comp-off Request</h2>
              <div className="space-y-4">
                <div className="p-3 rounded-lg bg-purple-50">
                  <p className="text-xs text-gray-500 font-medium">Employee</p>
                  <p className="font-semibold text-gray-900 text-base">{selectedCompOffRequest.employeeName}</p>
                  <p className="text-xs text-gray-500">{selectedCompOffRequest.employeeId}</p>
                </div>
                <div>
                  <label className="block mb-1 text-xs font-semibold text-gray-700">Extra Work Date</label>
                  <div className="p-2.5 rounded-lg bg-gray-50 border border-gray-200 text-sm">
                    <span className="font-medium text-gray-800">{formatDate(selectedCompOffRequest.workDate)}</span>
                    {selectedCompOffRequest.extraDayDetails?.workType && (
                      <span className="ml-2 text-xs font-semibold text-purple-700 bg-purple-100 px-2 py-0.5 rounded-full">
                        {selectedCompOffRequest.extraDayDetails.workType}
                      </span>
                    )}
                    {selectedCompOffRequest.extraDayDetails?.totalHours && (
                      <span className="ml-2 text-xs text-gray-500">({selectedCompOffRequest.extraDayDetails.totalHours} hrs)</span>
                    )}
                  </div>
                </div>
                <div>
                  <label className="block mb-1 text-xs font-semibold text-gray-700">Days Requested</label>
                  <div className="p-2 rounded-lg bg-gray-50 border border-gray-200 text-sm">{selectedCompOffRequest.count || 1} day(s)</div>
                </div>
                <div>
                  <label className="block mb-1 text-xs font-semibold text-gray-700">Reason</label>
                  <div className="p-2.5 rounded-lg bg-gray-50 border border-gray-200 text-sm text-gray-700 whitespace-pre-wrap">{selectedCompOffRequest.reason || 'No reason provided'}</div>
                </div>
                <div className="flex gap-2 pt-4">
                  <button onClick={() => { setShowCompOffPopup(false); setSelectedCompOffRequest(null); }} className="flex-1 px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 font-semibold text-xs transition-colors">Cancel</button>
                  <button onClick={rejectCompOffRequest} className="flex-1 px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 font-semibold text-xs transition-colors shadow-sm">Reject</button>
                  <button onClick={approveCompOffRequest} className="flex-1 px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 font-semibold text-xs transition-colors shadow-sm">Approve</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit Comp-off Popup (only for approved comp-offs) */}
        {showEditCompOffPopup && selectedCompOffForEdit && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div ref={editCompOffPopupRef} className="w-full max-w-sm p-4 bg-white rounded-md shadow-lg">
              <h2 className="mb-3 text-lg font-semibold text-green-700">Edit Comp-off</h2>
              <div className="space-y-3 text-sm">
                <div className="p-2 rounded bg-green-50"><p className="text-xs text-gray-500">Employee</p><p className="font-medium">{selectedCompOffForEdit.employeeName}</p><p className="text-[11px] text-gray-500">{selectedCompOffForEdit.employeeId}</p></div>
                <div><label className="block mb-0.5 text-xs font-medium text-gray-500">Work Date</label><div className="p-1.5 rounded bg-white text-xs">{formatDate(selectedCompOffForEdit.workDate)}</div></div>
                <div><label className="block mb-0.5 text-xs font-medium text-gray-500">Comp-off Days</label><input type="number" min="0.5" step="0.5" value={editCompOffData.count} onChange={(e) => setEditCompOffData({ ...editCompOffData, count: parseFloat(e.target.value) })} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded" /></div>
                <div><label className="block mb-0.5 text-xs font-medium text-gray-500">Reason</label><textarea rows="2" value={editCompOffData.reason} onChange={(e) => setEditCompOffData({ ...editCompOffData, reason: e.target.value })} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded" /></div>
                <div className="flex gap-2 pt-2">
                  <button onClick={() => { setShowEditCompOffPopup(false); setSelectedCompOffForEdit(null); }} className="flex-1 px-2 py-1.5 text-xs text-gray-600 bg-gray-100 rounded hover:bg-gray-200">Cancel</button>
                  <button onClick={rejectApprovedCompOff} className="flex-1 px-2 py-1.5 text-xs text-white bg-red-500 rounded hover:bg-red-600">Reject</button>
                  <button onClick={saveEditedCompOff} className="flex-1 px-2 py-1.5 text-xs text-white bg-green-600 rounded hover:bg-green-700">Save</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ Read-only View Comp-off Modal (for admin) */}
        {showViewCompOffModal && viewCompOffData && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl">
              <h2 className="mb-4 text-xl font-bold text-purple-800 flex items-center gap-2"><FaEye /> Comp-off Details</h2>
              <div className="space-y-4">
                <div className="flex justify-center">
                  <span className={`px-4 py-2 rounded-full text-sm font-semibold ${
                    viewCompOffData.status === "pending" ? "bg-yellow-100 text-yellow-700" :
                    viewCompOffData.status === "approved" ? "bg-green-100 text-green-700" :
                    "bg-red-100 text-red-700"
                  }`}>Status: {viewCompOffData.status}</span>
                </div>
                <div className="p-4 rounded-xl bg-purple-50 border border-purple-200">
                  <p className="text-sm font-semibold text-purple-800 mb-1">Work Date:</p>
                  <p className="text-sm font-medium">{formatDate(viewCompOffData.workDate)}</p>
                </div>
                <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
                  <p className="text-sm font-semibold text-gray-700 mb-1">Reason:</p>
                  <p className="text-sm text-gray-600">{viewCompOffData.reason}</p>
                </div>
                {viewCompOffData.count && (
                  <div className="p-4 rounded-xl bg-blue-50 border border-blue-200">
                    <p className="text-sm font-semibold text-blue-800 mb-1">Days:</p>
                    <p className="text-sm font-medium">{viewCompOffData.count} day(s)</p>
                  </div>
                )}
                {viewCompOffData.status === "rejected" && viewCompOffData.rejectedReason && (
                  <div className="p-3 rounded-xl bg-red-50 border border-red-200">
                    <p className="text-xs text-red-600">Rejected: {viewCompOffData.rejectedReason}</p>
                  </div>
                )}
              </div>
              <div className="mt-4 text-right">
                <button onClick={() => setShowViewCompOffModal(false)} className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-xl">Close</button>
              </div>
            </div>
          </div>
        )}

        {/* View Balances Popup */}
        {showBalancePopup && selectedEmpBalance && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div ref={balancePopupRef} className="w-full max-w-sm p-6 bg-white rounded-lg shadow-xl">
              <h2 className="mb-4 text-xl font-bold text-blue-800">Leave Balances</h2>
              <div className="p-3 mb-4 rounded-lg bg-blue-50">
                <p className="font-medium text-blue-900">{selectedEmpBalance.employeeName}</p>
                <p className="text-xs text-blue-600">{selectedEmpBalance.employeeId}</p>
              </div>
              <div className="space-y-2">
                <div className="flex justify-between p-2 rounded bg-white"><span className="font-medium">Casual Leave (CL)</span><span>{selectedEmpBalance.balances.CL.available} Left / {selectedEmpBalance.balances.CL.used} Used</span></div>
                <div className="flex justify-between p-2 rounded bg-white"><span className="font-medium">Sick Leave (SL)</span><span>{selectedEmpBalance.balances.SL.available} Left / {selectedEmpBalance.balances.SL.used} Used</span></div>
                <div className="flex justify-between p-2 rounded bg-white"><span className="font-medium">Earned Leave (EL)</span><span>{selectedEmpBalance.balances.EL.available} Left / {selectedEmpBalance.balances.EL.used} Used</span></div>
              </div>
              <div className="mt-4 text-right"><button onClick={() => setShowBalancePopup(false)} className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700">Close</button></div>
            </div>
          </div>
        )}

        {/* Main Table */}
        <div className="emp-dash__card overflow-hidden mb-6">
          {filteredLeaves.length === 0 ? (
            <div className="py-12 text-center text-gray-500 font-medium">No leave requests found matching current filter values.</div>
          ) : (
            <>
              <div className="hidden lg:block overflow-x-auto">
                <table className="emp-dash__table min-w-full">
                  <thead>
                    <tr>
                      <th className="text-left">Emp ID</th>
                      <th className="text-left">Name</th>
                      <th className="text-left">Department</th>
                      <th className="text-left">Designation</th>
                      <th className="text-center">Dates</th>
                      <th className="text-center">Days</th>
                      <th className="text-left">Reason</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Comp-off</th>
                      <th className="text-center">Approved By</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((l) => {
                      const empDetails = getEmployeeDetails(l.employeeId);
                      const compOffInfo = l.compOffStatus;
                      const userRole = localStorage.getItem("userRole");
                      const isManager = userRole === "employee" && JSON.parse(localStorage.getItem("employeePermissions") || "[]").includes("leave_approve");
                      const canApprove = (userRole === "admin" && (l.status === "pending" || l.status === "manager_approved")) || (isManager && l.status === "pending");

                      return (
                        <tr key={l._id} className={`hover:bg-gray-50 transition-all ${compOffInfo?.status === "approved" ? 'bg-purple-50' : ''}`}>
                          <td className="px-4 py-3 font-semibold text-gray-900 whitespace-nowrap">{l.employeeId || "N/A"}</td>
                          <td className="px-4 py-3 font-semibold text-gray-900 whitespace-nowrap">{l.employeeName}</td>
                          <td className="px-4 py-3 text-gray-600 truncate max-w-[150px]" title={empDetails.department}>{empDetails.department}</td>
                          <td className="px-4 py-3 text-gray-600 truncate max-w-[150px]" title={empDetails.designation}>{empDetails.designation}</td>
                          <td className="px-4 py-3 text-center">
                            <div className="text-gray-700 font-medium">{new Date(l.startDate).toLocaleDateString()}</div>
                            <div className="text-gray-400 text-xs">to</div>
                            <div className="text-gray-700 font-medium">{new Date(l.endDate).toLocaleDateString()}</div>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${compOffInfo?.status === "approved" ? 'bg-purple-100 text-purple-700 border border-purple-200' : 'bg-gray-100 text-gray-700 border border-gray-200'}`}>{l.days || 1}</span>
                          </td>
                          <td className="px-4 py-3 text-gray-600 truncate max-w-[200px]" title={l.reason}>{l.reason || "No reason provided"}</td>

                          <td className="px-4 py-3 text-center">
                            {l.status === "approved" && (<span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold text-green-700 bg-green-50 rounded-full border border-green-200"><span className="w-1.5 h-1.5 mr-1.5 bg-green-500 rounded-full"></span>Approved</span>)}
                            {l.status === "rejected" && (<span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold text-red-700 bg-red-50 rounded-full border border-red-200"><span className="w-1.5 h-1.5 mr-1.5 bg-red-500 rounded-full"></span>Rejected</span>)}
                            {l.status === "pending" && (<span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold text-amber-700 bg-amber-50 rounded-full border border-amber-200"><span className="w-1.5 h-1.5 mr-1.5 bg-amber-500 rounded-full"></span>Pending</span>)}
                            {l.status === "manager_approved" && (<span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold text-blue-700 bg-blue-50 rounded-full border border-blue-200"><span className="w-1.5 h-1.5 mr-1.5 bg-blue-500 rounded-full"></span>Manager Approved</span>)}
                          </td>

                          {/* ✅ Comp-off Column — READ-ONLY (no apply button) */}
                          <td className="px-4 py-3 text-center">
                            {compOffInfo ? (
                              <div className="flex flex-col items-center gap-1">
                                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                  compOffInfo.status === "pending" ? "bg-yellow-100 text-yellow-700 border border-yellow-200" :
                                  compOffInfo.status === "approved" ? "bg-green-100 text-green-700 border border-green-200" :
                                  "bg-red-100 text-red-700 border border-red-200"
                                }`}>
                                  {compOffInfo.status.charAt(0).toUpperCase() + compOffInfo.status.slice(1)}
                                </span>
                                {compOffInfo.workDate && (
                                  <span className="text-[10px] text-gray-500">{new Date(compOffInfo.workDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</span>
                                )}
                                <button
                                  onClick={() => openViewCompOffModal(compOffInfo.full || compOffInfo)}
                                  className="text-[10px] text-blue-600 hover:underline"
                                >
                                  View
                                </button>
                              </div>
                            ) : (
                              <span className="text-xs text-gray-400">—</span>
                            )}
                          </td>

                          <td className="px-4 py-3 text-center text-gray-500">{l.approvedBy || "-"}</td>
                          <td className="px-4 py-3 text-center">
                            <div className="flex items-center justify-center gap-1.5">
                              {canApprove && (
                                <>
                                  <button onClick={() => updateLeaveStatus(l._id, "approved")} className="p-1.5 text-green-600 bg-green-50 hover:bg-green-100 rounded-md transition-all shadow-sm" title="Approve"><FiCheckCircle className="w-4 h-4" /></button>
                                  <button onClick={() => updateLeaveStatus(l._id, "rejected")} className="p-1.5 text-red-600 bg-red-50 hover:bg-red-100 rounded-md transition-all shadow-sm" title="Reject"><FiXCircle className="w-4 h-4" /></button>
                                </>
                              )}
                              <button onClick={() => viewEmployeeBalances(l.employeeId, l.employeeName)} className="p-1.5 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-all shadow-sm" title="View Balances"><FiClock className="w-4 h-4" /></button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile View Card List */}
              <div className="block lg:hidden divide-y divide-gray-100">
                {currentItems.map((l) => {
                  const empDetails = getEmployeeDetails(l.employeeId);
                  const compOffInfo = l.compOffStatus;
                  const userRole = localStorage.getItem("userRole");
                  const isManager = userRole === "employee" && JSON.parse(localStorage.getItem("employeePermissions") || "[]").includes("leave_approve");
                  const canApprove = (userRole === "admin" && (l.status === "pending" || l.status === "manager_approved")) || (isManager && l.status === "pending");

                  return (
                    <div key={l._id} className={`p-4 ${compOffInfo?.status === "approved" ? 'bg-purple-50' : ''}`}>
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="font-semibold text-gray-900">{l.employeeName}</h4>
                          <span className="text-xs text-gray-500">{l.employeeId || "N/A"} • {empDetails.department}</span>
                        </div>
                        {l.status === "approved" && (<span className="px-2 py-1 text-xs font-semibold text-green-700 bg-green-50 rounded-full border border-green-200">Approved</span>)}
                        {l.status === "rejected" && (<span className="px-2 py-1 text-xs font-semibold text-red-700 bg-red-50 rounded-full border border-red-200">Rejected</span>)}
                        {l.status === "pending" && (<span className="px-2 py-1 text-xs font-semibold text-amber-700 bg-amber-50 rounded-full border border-amber-200">Pending</span>)}
                        {l.status === "manager_approved" && (<span className="px-2 py-1 text-xs font-semibold text-blue-700 bg-blue-50 rounded-full border border-blue-200">Manager Approved</span>)}
                      </div>

                      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs mb-3 text-gray-600">
                        <div><span className="text-gray-400">Designation:</span> {empDetails.designation}</div>
                        <div><span className="text-gray-400">Days:</span> {l.days || 1}</div>
                        <div className="col-span-2"><span className="text-gray-400">Dates:</span> {new Date(l.startDate).toLocaleDateString()} to {new Date(l.endDate).toLocaleDateString()}</div>
                        <div className="col-span-2"><span className="text-gray-400">Reason:</span> {l.reason || "No reason provided"}</div>
                        {compOffInfo && (
                          <div className="col-span-2">
                            <span className="text-gray-400">Comp-off:</span>{' '}
                            <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                              compOffInfo.status === "pending" ? "bg-yellow-100 text-yellow-700" :
                              compOffInfo.status === "approved" ? "bg-green-100 text-green-700" :
                              "bg-red-100 text-red-700"
                            }`}>{compOffInfo.status}</span>
                          </div>
                        )}
                      </div>

                      <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                        <span className="text-xs text-gray-500">Approved by: {l.approvedBy || "-"}</span>
                        <div className="flex gap-1.5 flex-wrap">
                          {canApprove && (
                            <>
                              <button onClick={() => updateLeaveStatus(l._id, "approved")} className="px-3 py-1.5 text-xs font-semibold text-green-700 bg-green-50 hover:bg-green-100 rounded-md transition-all">Approve</button>
                              <button onClick={() => updateLeaveStatus(l._id, "rejected")} className="px-3 py-1.5 text-xs font-semibold text-red-700 bg-red-50 hover:bg-red-100 rounded-md transition-all">Reject</button>
                            </>
                          )}
                          {compOffInfo && (
                            <button onClick={() => openViewCompOffModal(compOffInfo.full || compOffInfo)} className="px-3 py-1.5 text-xs font-semibold text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-md">View Comp-off</button>
                          )}
                          <button onClick={() => viewEmployeeBalances(l.employeeId, l.employeeName)} className="px-3 py-1.5 text-xs font-semibold text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-md transition-all">Balances</button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* Pagination */}
        {filteredLeaves.length > 0 && (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 border-t border-gray-200/50 bg-gray-50/30">
            <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500">
              <span>Show</span>
              <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="p-1 border border-gray-300 rounded-md bg-white text-gray-700 focus:outline-none">
                <option value={5}>5</option><option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
              </select>
              <span className="hidden sm:inline">entries per page</span>
              <span className="hidden sm:inline text-gray-300">|</span>
              <span className="text-[10px] sm:text-xs">Showing <strong>{indexOfFirstItem + 1}</strong> to <strong>{Math.min(indexOfLastItem, filteredLeaves.length)}</strong> of <strong>{filteredLeaves.length}</strong></span>
            </div>
            <div className="flex items-center gap-1.5">
              <button onClick={handlePrevPage} disabled={currentPage === 1} className={`px-2 py-1 text-xs font-semibold border rounded-lg transition-all ${currentPage === 1 ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50 border-gray-300 shadow-sm"}`}>Prev</button>
              {getPageNumbers().map((page, index) => (
                <button key={index} onClick={() => typeof page === 'number' ? handlePageClick(page) : null} disabled={page === "..."} className={`px-2.5 py-1 text-xs font-semibold border rounded-lg transition-all min-w-[28px] sm:min-w-[32px] ${page === "..." ? "text-gray-400 bg-transparent border-transparent cursor-default" : currentPage === page ? "text-white bg-blue-600 border-blue-600 shadow-sm" : "text-gray-700 bg-white hover:bg-gray-50 border-gray-300"}`}>{page}</button>
              ))}
              <button onClick={handleNextPage} disabled={currentPage === totalPages} className={`px-2 py-1 text-xs font-semibold border rounded-lg transition-all ${currentPage === totalPages ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50 border-gray-300 shadow-sm"}`}>Next</button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default LeavesList;